function PlanKK({ ...props }) {
	return (
		<g>
			<g id="furniture">
				<polyline
					points="642.09 514.72 640.44 514.72 640.44 511.47 642.09 511.47 642.09 514.72"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="701.02"
					y1="424.13"
					x2="828.24"
					y2="424.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="828.24"
					y1="424.13"
					x2="828.24"
					y2="448.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="828.24"
					y1="448.8"
					x2="825.8"
					y2="448.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.43"
					y1="448.8"
					x2="819.49"
					y2="448.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.12"
					y1="448.8"
					x2="813.17"
					y2="448.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.8"
					y1="448.8"
					x2="806.86"
					y2="448.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="804.49"
					y1="448.8"
					x2="800.55"
					y2="448.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.18"
					y1="448.8"
					x2="794.23"
					y2="448.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.86"
					y1="448.8"
					x2="787.92"
					y2="448.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.55"
					y1="448.8"
					x2="781.6"
					y2="448.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.24"
					y1="448.8"
					x2="775.29"
					y2="448.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.92"
					y1="448.8"
					x2="768.98"
					y2="448.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.61"
					y1="448.8"
					x2="762.66"
					y2="448.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.02"
					y1="442.42"
					x2="701.02"
					y2="438.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.02"
					y1="436.1"
					x2="701.02"
					y2="432.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.02"
					y1="429.79"
					x2="701.02"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.02"
					y1="425.78"
					x2="703.47"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.83"
					y1="425.78"
					x2="709.78"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.15"
					y1="425.78"
					x2="716.1"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.46"
					y1="425.78"
					x2="722.41"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.78"
					y1="425.78"
					x2="728.72"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.09"
					y1="425.78"
					x2="735.04"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.41"
					y1="425.78"
					x2="741.35"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.72"
					y1="425.78"
					x2="747.67"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.03"
					y1="425.78"
					x2="753.98"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.35"
					y1="425.78"
					x2="760.29"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.66"
					y1="425.78"
					x2="766.61"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.98"
					y1="425.78"
					x2="772.92"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.29"
					y1="425.78"
					x2="779.24"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.6"
					y1="425.78"
					x2="785.55"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.92"
					y1="425.78"
					x2="791.86"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.23"
					y1="425.78"
					x2="798.18"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="800.55"
					y1="425.78"
					x2="804.49"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.86"
					y1="425.78"
					x2="810.8"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="813.17"
					y1="425.78"
					x2="817.12"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.49"
					y1="425.78"
					x2="823.43"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.8"
					y1="425.78"
					x2="828.24"
					y2="425.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="828.24"
					y1="425.78"
					x2="828.24"
					y2="429.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="828.24"
					y1="432.16"
					x2="828.24"
					y2="436.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="828.24"
					y1="438.47"
					x2="828.24"
					y2="442.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="828.24"
					y1="444.79"
					x2="828.24"
					y2="448.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.62"
					y1="667.54"
					x2="669.62"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.65"
					y1="667.54"
					x2="661.59"
					y2="667.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.96"
					y1="667.54"
					x2="667.98"
					y2="667.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="667.54"
					x2="667.98"
					y2="671.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="673.53"
					x2="667.98"
					y2="677.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="679.85"
					x2="667.98"
					y2="683.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="686.16"
					x2="667.98"
					y2="690.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="692.48"
					x2="667.98"
					y2="696.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="698.79"
					x2="667.98"
					y2="702.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="705.1"
					x2="667.98"
					y2="709.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="711.42"
					x2="667.98"
					y2="715.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="717.73"
					x2="667.98"
					y2="721.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="724.05"
					x2="667.98"
					y2="727.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="730.36"
					x2="667.98"
					y2="734.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="736.67"
					x2="667.98"
					y2="740.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="742.99"
					x2="667.98"
					y2="746.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="749.3"
					x2="667.98"
					y2="753.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="755.61"
					x2="667.98"
					y2="759.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="761.93"
					x2="667.98"
					y2="765.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="768.24"
					x2="667.98"
					y2="772.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="774.56"
					x2="667.98"
					y2="778.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="780.87"
					x2="667.98"
					y2="784.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="787.19"
					x2="667.98"
					y2="791.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="793.5"
					x2="667.98"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.98"
					y1="797.12"
					x2="663.96"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="661.59"
					y1="797.12"
					x2="657.65"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.6"
					y1="676.86"
					x2="449.6"
					y2="801.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="741.03"
					x2="474.26"
					y2="737.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="734.71"
					x2="474.26"
					y2="730.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="728.4"
					x2="474.26"
					y2="724.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="722.08"
					x2="474.26"
					y2="718.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="715.77"
					x2="474.26"
					y2="711.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="709.46"
					x2="474.26"
					y2="705.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="703.14"
					x2="474.26"
					y2="699.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="696.83"
					x2="474.26"
					y2="692.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="690.52"
					x2="474.26"
					y2="686.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="684.2"
					x2="474.26"
					y2="680.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="678.08"
					x2="474.26"
					y2="676.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="676.86"
					x2="470.25"
					y2="676.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.25"
					y1="676.86"
					x2="451.24"
					y2="676.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="676.86"
					x2="451.24"
					y2="678.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="680.25"
					x2="451.24"
					y2="684.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="686.57"
					x2="451.24"
					y2="690.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="692.88"
					x2="451.24"
					y2="696.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="699.2"
					x2="451.24"
					y2="703.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="705.51"
					x2="451.24"
					y2="709.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="711.83"
					x2="451.24"
					y2="715.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="718.14"
					x2="451.24"
					y2="722.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="724.45"
					x2="451.24"
					y2="728.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="730.77"
					x2="451.24"
					y2="734.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="737.08"
					x2="451.24"
					y2="741.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="743.39"
					x2="451.24"
					y2="747.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="749.71"
					x2="451.24"
					y2="753.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="756.02"
					x2="451.24"
					y2="759.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="762.34"
					x2="451.24"
					y2="766.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="768.65"
					x2="451.24"
					y2="772.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="774.96"
					x2="451.24"
					y2="778.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="781.28"
					x2="451.24"
					y2="785.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="787.59"
					x2="451.24"
					y2="791.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="793.91"
					x2="451.24"
					y2="797.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="800.03"
					x2="451.24"
					y2="801.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.24"
					y1="801.25"
					x2="455.25"
					y2="801.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.62"
					y1="801.25"
					x2="461.57"
					y2="801.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="691.49 610.24 691.49 654.63 647.09 654.63 647.09 610.24 691.49 610.24"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="656.93 166.24 656.93 169.8 685.44 169.8 685.44 166.24 656.93 166.24"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="686.74 165.91 655.63 165.91 655.63 166.24 686.74 166.24 686.74 165.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="686.74"
					y1="166.24"
					x2="686.74"
					y2="165.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.63"
					y1="166.24"
					x2="686.74"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.63"
					y1="165.91"
					x2="655.63"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.74"
					y1="165.91"
					x2="655.63"
					y2="165.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.93"
					y1="169.8"
					x2="685.44"
					y2="169.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.44"
					y1="166.24"
					x2="656.93"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="654.02 169.8 656.93 169.8 656.93 166.24 654.02 166.24 654.02 169.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="654.02"
					y1="166.24"
					x2="654.02"
					y2="169.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.93"
					y1="166.24"
					x2="654.02"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.93"
					y1="169.8"
					x2="656.93"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.02"
					y1="169.8"
					x2="656.93"
					y2="169.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="688.35 166.24 685.44 166.24 685.44 169.8 688.35 169.8 688.35 166.24"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="688.35"
					y1="169.8"
					x2="688.35"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.44"
					y1="169.8"
					x2="688.35"
					y2="169.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.44"
					y1="166.24"
					x2="685.44"
					y2="169.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.35"
					y1="166.24"
					x2="685.44"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.93"
					y1="166.88"
					x2="685.44"
					y2="166.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="652.72 169.47 654.02 169.47 654.02 166.24 655.63 166.24 655.63 165.91 652.72 165.91 652.72 169.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="652.72"
					y1="165.91"
					x2="652.72"
					y2="169.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.63"
					y1="165.91"
					x2="652.72"
					y2="165.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.63"
					y1="166.24"
					x2="655.63"
					y2="165.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.02"
					y1="166.24"
					x2="655.63"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.02"
					y1="169.47"
					x2="654.02"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.72"
					y1="169.47"
					x2="654.02"
					y2="169.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="689.65 165.91 686.74 165.91 686.74 166.24 688.35 166.24 688.35 169.47 689.65 169.47 689.65 165.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="689.65"
					y1="169.47"
					x2="689.65"
					y2="165.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.35"
					y1="169.47"
					x2="689.65"
					y2="169.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.35"
					y1="166.24"
					x2="688.35"
					y2="169.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.74"
					y1="166.24"
					x2="688.35"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.74"
					y1="165.91"
					x2="686.74"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.65"
					y1="165.91"
					x2="686.74"
					y2="165.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="691.29 166.88 691.29 168.53 777.51 168.53 777.51 166.88 691.29 166.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="777.51"
					y1="166.88"
					x2="691.29"
					y2="166.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.51"
					y1="168.53"
					x2="777.51"
					y2="166.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.29"
					y1="168.53"
					x2="777.51"
					y2="168.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.29"
					y1="166.88"
					x2="691.29"
					y2="168.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="652.72 166.88 652.72 176.75 649.43 176.75 649.43 166.88 652.72 166.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="652.72"
					y1="176.75"
					x2="652.72"
					y2="166.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.43"
					y1="176.75"
					x2="652.72"
					y2="176.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.43"
					y1="166.88"
					x2="649.43"
					y2="176.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.72"
					y1="166.88"
					x2="649.43"
					y2="166.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="692.94 166.88 692.94 176.75 689.65 176.75 689.65 166.88 692.94 166.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="692.94"
					y1="176.75"
					x2="692.94"
					y2="166.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.65"
					y1="176.75"
					x2="692.94"
					y2="176.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.65"
					y1="166.88"
					x2="689.65"
					y2="176.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.94"
					y1="166.88"
					x2="689.65"
					y2="166.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="779.15 166.88 779.15 176.75 775.86 176.75 775.86 166.88 779.15 166.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="779.15"
					y1="176.75"
					x2="779.15"
					y2="166.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.86"
					y1="176.75"
					x2="779.15"
					y2="176.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.86"
					y1="166.88"
					x2="775.86"
					y2="176.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.15"
					y1="166.88"
					x2="775.86"
					y2="166.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="439.69 166.24 439.69 169.8 468.2 169.8 468.2 166.24 439.69 166.24"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="469.5 165.91 438.4 165.91 438.4 166.24 469.5 166.24 469.5 165.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="469.5"
					y1="166.24"
					x2="469.5"
					y2="165.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="438.4"
					y1="166.24"
					x2="469.5"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="438.4"
					y1="165.91"
					x2="438.4"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.5"
					y1="165.91"
					x2="438.4"
					y2="165.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.69"
					y1="169.8"
					x2="468.2"
					y2="169.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.2"
					y1="166.24"
					x2="439.69"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="436.78 169.8 439.69 169.8 439.69 166.24 436.78 166.24 436.78 169.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="436.78"
					y1="166.24"
					x2="436.78"
					y2="169.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.69"
					y1="166.24"
					x2="436.78"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.69"
					y1="169.8"
					x2="439.69"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.78"
					y1="169.8"
					x2="439.69"
					y2="169.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="471.12 166.24 468.2 166.24 468.2 169.8 471.12 169.8 471.12 166.24"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="471.12"
					y1="169.8"
					x2="471.12"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.2"
					y1="169.8"
					x2="471.12"
					y2="169.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.2"
					y1="166.24"
					x2="468.2"
					y2="169.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.12"
					y1="166.24"
					x2="468.2"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.69"
					y1="166.88"
					x2="468.2"
					y2="166.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="435.48 169.47 436.78 169.47 436.78 166.24 438.4 166.24 438.4 165.91 435.48 165.91 435.48 169.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="435.48"
					y1="165.91"
					x2="435.48"
					y2="169.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="438.4"
					y1="165.91"
					x2="435.48"
					y2="165.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="438.4"
					y1="166.24"
					x2="438.4"
					y2="165.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.78"
					y1="166.24"
					x2="438.4"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.78"
					y1="169.47"
					x2="436.78"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.48"
					y1="169.47"
					x2="436.78"
					y2="169.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="472.41 165.91 469.5 165.91 469.5 166.24 471.12 166.24 471.12 169.47 472.41 169.47 472.41 165.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="472.41"
					y1="169.47"
					x2="472.41"
					y2="165.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.12"
					y1="169.47"
					x2="472.41"
					y2="169.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.12"
					y1="166.24"
					x2="471.12"
					y2="169.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.5"
					y1="166.24"
					x2="471.12"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.5"
					y1="165.91"
					x2="469.5"
					y2="166.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.41"
					y1="165.91"
					x2="469.5"
					y2="165.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="474.06 166.88 474.06 168.53 560.27 168.53 560.27 166.88 474.06 166.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="560.27"
					y1="166.88"
					x2="474.06"
					y2="166.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="560.27"
					y1="168.53"
					x2="560.27"
					y2="166.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.06"
					y1="168.53"
					x2="560.27"
					y2="168.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.06"
					y1="166.88"
					x2="474.06"
					y2="168.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="435.48 166.88 435.48 176.75 432.2 176.75 432.2 166.88 435.48 166.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="435.48"
					y1="176.75"
					x2="435.48"
					y2="166.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.2"
					y1="176.75"
					x2="435.48"
					y2="176.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.2"
					y1="166.88"
					x2="432.2"
					y2="176.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.48"
					y1="166.88"
					x2="432.2"
					y2="166.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="475.7 166.88 475.7 176.75 472.41 176.75 472.41 166.88 475.7 166.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="475.7"
					y1="176.75"
					x2="475.7"
					y2="166.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.41"
					y1="176.75"
					x2="475.7"
					y2="176.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.41"
					y1="166.88"
					x2="472.41"
					y2="176.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.7"
					y1="166.88"
					x2="472.41"
					y2="166.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="561.92 166.88 561.92 176.75 558.63 176.75 558.63 166.88 561.92 166.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="561.92"
					y1="176.75"
					x2="561.92"
					y2="166.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.63"
					y1="176.75"
					x2="561.92"
					y2="176.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.63"
					y1="166.88"
					x2="558.63"
					y2="176.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.92"
					y1="166.88"
					x2="558.63"
					y2="166.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="214.2 632.76 214.2 661.28 217.76 661.28 217.76 632.76 214.2 632.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="213.87 662.57 213.87 631.47 214.2 631.47 214.2 662.57 213.87 662.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="213.87"
					y1="662.57"
					x2="213.87"
					y2="631.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.87"
					y1="631.47"
					x2="214.2"
					y2="631.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.2"
					y1="631.47"
					x2="214.2"
					y2="662.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.2"
					y1="662.57"
					x2="213.87"
					y2="662.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.76"
					y1="632.76"
					x2="217.76"
					y2="661.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.2"
					y1="661.28"
					x2="214.2"
					y2="632.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="217.76 629.85 217.76 632.76 214.2 632.76 214.2 629.85 217.76 629.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="217.76"
					y1="629.85"
					x2="217.76"
					y2="632.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.76"
					y1="632.76"
					x2="214.2"
					y2="632.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.2"
					y1="632.76"
					x2="214.2"
					y2="629.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.2"
					y1="629.85"
					x2="217.76"
					y2="629.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="214.2 664.19 214.2 661.28 217.76 661.28 217.76 664.19 214.2 664.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="214.2"
					y1="664.19"
					x2="214.2"
					y2="661.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.2"
					y1="661.28"
					x2="217.76"
					y2="661.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.76"
					y1="661.28"
					x2="217.76"
					y2="664.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.76"
					y1="664.19"
					x2="214.2"
					y2="664.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.84"
					y1="632.76"
					x2="214.84"
					y2="661.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="217.43 628.56 217.43 629.85 214.2 629.85 214.2 631.47 213.87 631.47 213.87 628.56 217.43 628.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="217.43"
					y1="628.56"
					x2="217.43"
					y2="629.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.43"
					y1="629.85"
					x2="214.2"
					y2="629.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.2"
					y1="629.85"
					x2="214.2"
					y2="631.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.2"
					y1="631.47"
					x2="213.87"
					y2="631.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.87"
					y1="631.47"
					x2="213.87"
					y2="628.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.87"
					y1="628.56"
					x2="217.43"
					y2="628.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="213.87 665.48 213.87 662.57 214.2 662.57 214.2 664.19 217.43 664.19 217.43 665.48 213.87 665.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="213.87"
					y1="665.48"
					x2="213.87"
					y2="662.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.87"
					y1="662.57"
					x2="214.2"
					y2="662.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.2"
					y1="662.57"
					x2="214.2"
					y2="664.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.2"
					y1="664.19"
					x2="217.43"
					y2="664.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.43"
					y1="664.19"
					x2="217.43"
					y2="665.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.43"
					y1="665.48"
					x2="213.87"
					y2="665.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="214.84 667.13 216.49 667.13 216.49 753.34 214.84 753.34 214.84 667.13"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="214.84"
					y1="667.13"
					x2="216.49"
					y2="667.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.49"
					y1="667.13"
					x2="216.49"
					y2="753.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.49"
					y1="753.34"
					x2="214.84"
					y2="753.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.84"
					y1="753.34"
					x2="214.84"
					y2="667.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="214.84 628.56 214.84 625.27 224.71 625.27 224.71 628.56 214.84 628.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="214.84"
					y1="625.27"
					x2="214.84"
					y2="628.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.71"
					y1="625.27"
					x2="214.84"
					y2="625.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.71"
					y1="628.56"
					x2="224.71"
					y2="625.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.84"
					y1="628.56"
					x2="224.71"
					y2="628.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="214.84 668.77 214.84 665.48 224.71 665.48 224.71 668.77 214.84 668.77"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="214.84"
					y1="665.48"
					x2="214.84"
					y2="668.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.71"
					y1="665.48"
					x2="214.84"
					y2="665.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.71"
					y1="668.77"
					x2="224.71"
					y2="665.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.84"
					y1="668.77"
					x2="224.71"
					y2="668.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="214.84 754.99 214.84 751.7 224.71 751.7 224.71 754.99 214.84 754.99"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="214.84"
					y1="751.7"
					x2="214.84"
					y2="754.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.71"
					y1="751.7"
					x2="214.84"
					y2="751.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.71"
					y1="754.99"
					x2="224.71"
					y2="751.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.84"
					y1="754.99"
					x2="224.71"
					y2="754.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="335.51 458.53 292.39 458.53 292.39 461.76 335.51 461.76 335.51 458.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="335.51"
					y1="461.76"
					x2="335.51"
					y2="458.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="292.39"
					y1="461.76"
					x2="335.51"
					y2="461.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="292.39"
					y1="458.53"
					x2="292.39"
					y2="461.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.51"
					y1="458.53"
					x2="292.39"
					y2="458.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.51"
					y1="461.12"
					x2="292.39"
					y2="461.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.51"
					y1="461.76"
					x2="292.39"
					y2="461.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.51"
					y1="458.53"
					x2="292.39"
					y2="458.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="343.28 458.53 335.51 458.53 335.51 461.76 343.28 461.76 343.28 458.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="343.28"
					y1="461.76"
					x2="343.28"
					y2="458.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.51"
					y1="461.76"
					x2="343.28"
					y2="461.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.51"
					y1="458.53"
					x2="335.51"
					y2="461.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.28"
					y1="458.53"
					x2="335.51"
					y2="458.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="292.39 458.53 284.62 458.53 284.62 461.76 292.39 461.76 292.39 458.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="292.39"
					y1="461.76"
					x2="292.39"
					y2="458.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.62"
					y1="461.76"
					x2="292.39"
					y2="461.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.62"
					y1="458.53"
					x2="284.62"
					y2="461.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="292.39"
					y1="458.53"
					x2="284.62"
					y2="458.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="346.84 463.06 346.84 460.14 346.52 460.14 346.52 461.76 343.28 461.76 343.28 463.06 346.84 463.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="343.28"
					y1="463.06"
					x2="346.84"
					y2="463.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.28"
					y1="461.76"
					x2="343.28"
					y2="463.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.52"
					y1="461.76"
					x2="343.28"
					y2="461.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.52"
					y1="460.14"
					x2="346.52"
					y2="461.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.84"
					y1="460.14"
					x2="346.52"
					y2="460.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.84"
					y1="463.06"
					x2="346.84"
					y2="460.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="343.28 401.81 343.28 403.1 346.52 403.1 346.52 404.72 346.84 404.72 346.84 401.81 343.28 401.81"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="346.84"
					y1="401.81"
					x2="343.28"
					y2="401.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.84"
					y1="404.72"
					x2="346.84"
					y2="401.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.52"
					y1="404.72"
					x2="346.84"
					y2="404.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.52"
					y1="403.1"
					x2="346.52"
					y2="404.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.28"
					y1="403.1"
					x2="346.52"
					y2="403.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.28"
					y1="401.81"
					x2="343.28"
					y2="403.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="343.93 400.16 345.57 400.16 345.57 337.24 343.93 337.24 343.93 400.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="343.93"
					y1="337.24"
					x2="343.93"
					y2="400.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.57"
					y1="337.24"
					x2="343.93"
					y2="337.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.57"
					y1="400.16"
					x2="345.57"
					y2="337.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.93"
					y1="400.16"
					x2="345.57"
					y2="400.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="343.93 337.24 345.57 337.24 345.57 279.82 343.93 279.82 343.93 337.24"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="343.93"
					y1="279.82"
					x2="343.93"
					y2="337.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.57"
					y1="279.82"
					x2="343.93"
					y2="279.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.57"
					y1="337.24"
					x2="345.57"
					y2="279.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.93"
					y1="337.24"
					x2="345.57"
					y2="337.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="343.93 279.82 345.57 279.82 345.57 219.68 343.93 219.68 343.93 279.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="343.93"
					y1="219.68"
					x2="343.93"
					y2="279.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.57"
					y1="219.68"
					x2="343.93"
					y2="219.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.57"
					y1="279.82"
					x2="345.57"
					y2="219.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.93"
					y1="279.82"
					x2="345.57"
					y2="279.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="343.93 463.06 353.79 463.06 353.79 466.34 343.93 466.34 343.93 463.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="353.79"
					y1="463.06"
					x2="343.93"
					y2="463.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.79"
					y1="466.34"
					x2="353.79"
					y2="463.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.93"
					y1="466.34"
					x2="353.79"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.93"
					y1="463.06"
					x2="343.93"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="343.93 398.52 353.79 398.52 353.79 401.81 343.93 401.81 343.93 398.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="353.79"
					y1="398.52"
					x2="343.93"
					y2="398.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.79"
					y1="401.81"
					x2="353.79"
					y2="398.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.93"
					y1="401.81"
					x2="353.79"
					y2="401.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.93"
					y1="398.52"
					x2="343.93"
					y2="401.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="343.93 335.6 353.79 335.6 353.79 338.88 343.93 338.88 343.93 335.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="353.79"
					y1="335.6"
					x2="343.93"
					y2="335.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.79"
					y1="338.88"
					x2="353.79"
					y2="335.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.93"
					y1="338.88"
					x2="353.79"
					y2="338.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.93"
					y1="335.6"
					x2="343.93"
					y2="338.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="343.93 218.03 353.79 218.03 353.79 221.32 343.93 221.32 343.93 218.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="353.79"
					y1="218.03"
					x2="343.93"
					y2="218.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.79"
					y1="221.32"
					x2="353.79"
					y2="218.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.93"
					y1="221.32"
					x2="353.79"
					y2="221.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.93"
					y1="218.03"
					x2="343.93"
					y2="221.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="343.93 278.18 353.79 278.18 353.79 281.46 343.93 281.46 343.93 278.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="353.79"
					y1="278.18"
					x2="343.93"
					y2="278.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.79"
					y1="281.46"
					x2="353.79"
					y2="278.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.93"
					y1="281.46"
					x2="353.79"
					y2="281.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.93"
					y1="278.18"
					x2="343.93"
					y2="281.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.94"
					y1="810.28"
					x2="785.4"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="782.94"
					y1="797.12"
					x2="785.4"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="782.94"
					y1="797.12"
					x2="782.94"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="720.46"
					y1="810.28"
					x2="717.99"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="720.46"
					y1="797.12"
					x2="717.99"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="720.46"
					y1="797.12"
					x2="720.46"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="720.46"
					y1="797.12"
					x2="694.27"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="721.28 811.1 721.28 810.28 717.99 810.28 717.99 811.1 721.28 811.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="782.12 810.28 782.12 811.1 785.4 811.1 785.4 810.28 782.12 810.28"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="721.28 797.12 721.28 796.3 717.99 796.3 717.99 797.12 721.28 797.12"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="782.12 796.3 782.12 797.12 785.4 797.12 785.4 796.3 782.12 796.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="721.28"
					y1="811.1"
					x2="717.99"
					y2="811.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.99"
					y1="811.1"
					x2="717.99"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.99"
					y1="810.28"
					x2="721.28"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.28"
					y1="810.28"
					x2="721.28"
					y2="811.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.12"
					y1="810.28"
					x2="785.4"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.4"
					y1="810.28"
					x2="785.4"
					y2="811.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.4"
					y1="811.1"
					x2="782.12"
					y2="811.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.12"
					y1="811.1"
					x2="782.12"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.28"
					y1="797.12"
					x2="717.99"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.99"
					y1="797.12"
					x2="717.99"
					y2="796.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.99"
					y1="796.3"
					x2="721.28"
					y2="796.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.28"
					y1="796.3"
					x2="721.28"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.12"
					y1="796.3"
					x2="785.4"
					y2="796.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.4"
					y1="796.3"
					x2="785.4"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.4"
					y1="797.12"
					x2="782.12"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.12"
					y1="797.12"
					x2="782.12"
					y2="796.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="722.1 810.28 722.1 797.12 720.87 797.12 720.87 810.28 722.1 810.28"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="782.53 810.28 782.53 797.12 781.29 797.12 781.29 810.28 782.53 810.28"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="739.44 755.26 737.4 757.3 779.26 799.16 781.29 797.12 739.44 755.26"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="720.87"
					y1="797.12"
					x2="720.46"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.87"
					y1="810.28"
					x2="720.46"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.46"
					y1="797.12"
					x2="720.46"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.53"
					y1="797.12"
					x2="782.94"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.53"
					y1="810.28"
					x2="782.94"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.94"
					y1="797.12"
					x2="782.94"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.1"
					y1="810.28"
					x2="722.1"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.1"
					y1="797.12"
					x2="720.87"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.87"
					y1="797.12"
					x2="720.87"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.87"
					y1="810.28"
					x2="722.1"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.53"
					y1="810.28"
					x2="782.53"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.53"
					y1="797.12"
					x2="781.29"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.29"
					y1="797.12"
					x2="781.29"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.29"
					y1="810.28"
					x2="782.53"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.44"
					y1="755.26"
					x2="737.4"
					y2="757.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.4"
					y1="757.3"
					x2="779.26"
					y2="799.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.26"
					y1="799.16"
					x2="781.29"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.29"
					y1="797.12"
					x2="739.44"
					y2="755.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.46"
					y1="797.12"
					x2="720.46"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="720.46"
					y1="797.12"
					x2="720.46"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="720.46"
					y1="797.12"
					x2="717.99"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="720.46"
					y1="797.12"
					x2="717.99"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="720.46"
					y1="810.28"
					x2="717.99"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="720.46"
					y1="810.28"
					x2="717.99"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="782.94"
					y1="797.12"
					x2="782.94"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="782.94"
					y1="797.12"
					x2="782.94"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="782.94"
					y1="797.12"
					x2="785.4"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="782.94"
					y1="797.12"
					x2="785.4"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="782.94"
					y1="810.28"
					x2="785.4"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="782.94"
					y1="810.28"
					x2="785.4"
					y2="810.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="779.15"
					y1="163.6"
					x2="779.15"
					y2="176.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="340.64"
					y1="218.03"
					x2="353.79"
					y2="218.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="211.55"
					y1="625.27"
					x2="224.71"
					y2="625.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="644.96"
					y1="659.32"
					x2="644.96"
					y2="605.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="576.31"
					x2="638.8"
					y2="576.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="431.04"
					y1="562.22"
					x2="431.04"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="362"
					y1="522.76"
					x2="359.53"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="362"
					y1="530.98"
					x2="359.53"
					y2="530.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="362"
					y1="530.98"
					x2="362"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="414.61"
					y1="522.76"
					x2="417.08"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="414.61"
					y1="530.98"
					x2="417.08"
					y2="530.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="414.61"
					y1="530.98"
					x2="414.61"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="362"
					y1="522.76"
					x2="353.79"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="353.79"
					y1="530.98"
					x2="362"
					y2="530.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="413.79 521.93 413.79 522.76 417.08 522.76 417.08 521.93 413.79 521.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="362.82 522.76 362.82 521.93 359.53 521.93 359.53 522.76 362.82 522.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="413.79 530.98 413.79 531.8 417.08 531.8 417.08 530.98 413.79 530.98"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="362.82 531.8 362.82 530.98 359.53 530.98 359.53 531.8 362.82 531.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="413.79"
					y1="521.93"
					x2="417.08"
					y2="521.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.08"
					y1="521.93"
					x2="417.08"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.08"
					y1="522.76"
					x2="413.79"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.79"
					y1="522.76"
					x2="413.79"
					y2="521.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.82"
					y1="522.76"
					x2="359.53"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.53"
					y1="522.76"
					x2="359.53"
					y2="521.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.53"
					y1="521.93"
					x2="362.82"
					y2="521.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.82"
					y1="521.93"
					x2="362.82"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.79"
					y1="530.98"
					x2="417.08"
					y2="530.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.08"
					y1="530.98"
					x2="417.08"
					y2="531.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.08"
					y1="531.8"
					x2="413.79"
					y2="531.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.79"
					y1="531.8"
					x2="413.79"
					y2="530.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.82"
					y1="531.8"
					x2="359.53"
					y2="531.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.53"
					y1="531.8"
					x2="359.53"
					y2="530.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.53"
					y1="530.98"
					x2="362.82"
					y2="530.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.82"
					y1="530.98"
					x2="362.82"
					y2="531.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="412.97 522.76 412.97 530.98 414.2 530.98 414.2 522.76 412.97 522.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="362.41 522.76 362.41 530.98 363.64 530.98 363.64 522.76 362.41 522.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="398.52 565.86 400.55 563.83 365.68 528.95 363.64 530.98 398.52 565.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="414.2"
					y1="530.98"
					x2="414.61"
					y2="530.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.2"
					y1="522.76"
					x2="414.61"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.61"
					y1="530.98"
					x2="414.61"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.41"
					y1="530.98"
					x2="362"
					y2="530.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.41"
					y1="522.76"
					x2="362"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362"
					y1="530.98"
					x2="362"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.97"
					y1="522.76"
					x2="412.97"
					y2="530.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.97"
					y1="530.98"
					x2="414.2"
					y2="530.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.2"
					y1="530.98"
					x2="414.2"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.2"
					y1="522.76"
					x2="412.97"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.41"
					y1="522.76"
					x2="362.41"
					y2="530.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.41"
					y1="530.98"
					x2="363.64"
					y2="530.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.64"
					y1="530.98"
					x2="363.64"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.64"
					y1="522.76"
					x2="362.41"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.52"
					y1="565.86"
					x2="400.55"
					y2="563.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.55"
					y1="563.83"
					x2="365.68"
					y2="528.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.68"
					y1="528.95"
					x2="363.64"
					y2="530.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.64"
					y1="530.98"
					x2="398.52"
					y2="565.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.61"
					y1="530.98"
					x2="414.61"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="414.61"
					y1="530.98"
					x2="414.61"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="414.61"
					y1="530.98"
					x2="417.08"
					y2="530.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="414.61"
					y1="530.98"
					x2="417.08"
					y2="530.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="414.61"
					y1="522.76"
					x2="417.08"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="414.61"
					y1="522.76"
					x2="417.08"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="362"
					y1="530.98"
					x2="362"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="362"
					y1="530.98"
					x2="362"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="362"
					y1="530.98"
					x2="359.53"
					y2="530.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="362"
					y1="530.98"
					x2="359.53"
					y2="530.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="362"
					y1="522.76"
					x2="359.53"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="362"
					y1="522.76"
					x2="359.53"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="686.05"
					y1="657.1"
					x2="686.05"
					y2="659.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="657.1"
					x2="694.27"
					y2="659.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="657.1"
					x2="686.05"
					y2="657.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="686.05"
					y1="607.77"
					x2="686.05"
					y2="605.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="607.77"
					x2="694.27"
					y2="605.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="607.77"
					x2="686.05"
					y2="607.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="686.05"
					y1="679.31"
					x2="686.05"
					y2="677.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="687.69"
					y1="679.31"
					x2="686.05"
					y2="679.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="679.31"
					x2="694.27"
					y2="677.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="679.31"
					x2="687.69"
					y2="679.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="686.05"
					y1="785.36"
					x2="686.05"
					y2="787.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="687.69"
					y1="785.36"
					x2="686.05"
					y2="785.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="785.36"
					x2="694.27"
					y2="787.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="785.36"
					x2="687.69"
					y2="785.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="797.12"
					x2="694.27"
					y2="785.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="686.05"
					y1="605.55"
					x2="686.05"
					y2="607.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="686.05"
					y1="657.1"
					x2="686.05"
					y2="659.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="686.05"
					y1="667.54"
					x2="686.05"
					y2="679.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="686.05"
					y1="785.36"
					x2="686.05"
					y2="797.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="685.23 608.59 686.05 608.59 686.05 605.3 685.23 605.3 685.23 608.59"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="686.05 656.28 685.23 656.28 685.23 659.57 686.05 659.57 686.05 656.28"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="694.27 608.59 695.09 608.59 695.09 605.3 694.27 605.3 694.27 608.59"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="695.09 656.28 694.27 656.28 694.27 659.57 695.09 659.57 695.09 656.28"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="685.23"
					y1="608.59"
					x2="685.23"
					y2="605.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.23"
					y1="605.3"
					x2="686.05"
					y2="605.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.05"
					y1="605.3"
					x2="686.05"
					y2="608.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.05"
					y1="608.59"
					x2="685.23"
					y2="608.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.05"
					y1="656.28"
					x2="686.05"
					y2="659.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.05"
					y1="659.57"
					x2="685.23"
					y2="659.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.23"
					y1="659.57"
					x2="685.23"
					y2="656.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.23"
					y1="656.28"
					x2="686.05"
					y2="656.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="608.59"
					x2="694.27"
					y2="605.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="605.3"
					x2="695.09"
					y2="605.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.09"
					y1="605.3"
					x2="695.09"
					y2="608.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.09"
					y1="608.59"
					x2="694.27"
					y2="608.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.09"
					y1="656.28"
					x2="695.09"
					y2="659.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.09"
					y1="659.57"
					x2="694.27"
					y2="659.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="659.57"
					x2="694.27"
					y2="656.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="656.28"
					x2="695.09"
					y2="656.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="686.05 609.42 694.27 609.42 694.27 608.18 686.05 608.18 686.05 609.42"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="686.05 656.69 694.27 656.69 694.27 655.45 686.05 655.45 686.05 656.69"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="726.83 622.9 724.79 620.86 692.24 653.42 694.27 655.45 726.83 622.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="694.27"
					y1="608.18"
					x2="694.27"
					y2="607.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.05"
					y1="608.18"
					x2="686.05"
					y2="607.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="607.77"
					x2="686.05"
					y2="607.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="656.69"
					x2="694.27"
					y2="657.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.05"
					y1="656.69"
					x2="686.05"
					y2="657.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="657.1"
					x2="686.05"
					y2="657.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.05"
					y1="609.42"
					x2="694.27"
					y2="609.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="609.42"
					x2="694.27"
					y2="608.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="608.18"
					x2="686.05"
					y2="608.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.05"
					y1="608.18"
					x2="686.05"
					y2="609.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.05"
					y1="656.69"
					x2="694.27"
					y2="656.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="656.69"
					x2="694.27"
					y2="655.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="655.45"
					x2="686.05"
					y2="655.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.05"
					y1="655.45"
					x2="686.05"
					y2="656.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.83"
					y1="622.9"
					x2="724.79"
					y2="620.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.79"
					y1="620.86"
					x2="692.24"
					y2="653.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.24"
					y1="653.42"
					x2="694.27"
					y2="655.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="655.45"
					x2="726.83"
					y2="622.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="607.77"
					x2="686.05"
					y2="607.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="607.77"
					x2="686.05"
					y2="607.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="607.77"
					x2="694.27"
					y2="605.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="607.77"
					x2="694.27"
					y2="605.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="686.05"
					y1="607.77"
					x2="686.05"
					y2="605.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="686.05"
					y1="607.77"
					x2="686.05"
					y2="605.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="657.1"
					x2="686.05"
					y2="657.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="657.1"
					x2="686.05"
					y2="657.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="657.1"
					x2="694.27"
					y2="659.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="657.1"
					x2="694.27"
					y2="659.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="686.05"
					y1="657.1"
					x2="686.05"
					y2="659.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="686.05"
					y1="657.1"
					x2="686.05"
					y2="659.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="687.69 784.13 686.05 784.13 686.05 784.95 687.69 784.95 687.69 784.13"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="685.23 784.13 685.23 787.42 686.05 787.42 686.05 784.13 685.23 784.13"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="687.69 679.72 686.05 679.72 686.05 680.54 687.69 680.54 687.69 679.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="686.05 680.54 686.05 677.25 685.23 677.25 685.23 680.54 686.05 680.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="694.27 784.13 694.27 787.42 696.33 787.42 696.33 784.13 694.27 784.13"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="696.33 680.54 696.33 677.25 694.27 677.25 694.27 680.54 696.33 680.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="687.69"
					y1="784.13"
					x2="686.05"
					y2="784.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.05"
					y1="784.13"
					x2="686.05"
					y2="784.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.05"
					y1="784.95"
					x2="687.69"
					y2="784.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.69"
					y1="784.95"
					x2="687.69"
					y2="784.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.23"
					y1="784.13"
					x2="685.23"
					y2="787.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.23"
					y1="787.42"
					x2="686.05"
					y2="787.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.05"
					y1="787.42"
					x2="686.05"
					y2="784.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.05"
					y1="784.13"
					x2="685.23"
					y2="784.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.69"
					y1="679.72"
					x2="686.05"
					y2="679.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.05"
					y1="679.72"
					x2="686.05"
					y2="680.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.05"
					y1="680.54"
					x2="687.69"
					y2="680.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.69"
					y1="680.54"
					x2="687.69"
					y2="679.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.05"
					y1="680.54"
					x2="686.05"
					y2="677.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.05"
					y1="677.25"
					x2="685.23"
					y2="677.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.23"
					y1="677.25"
					x2="685.23"
					y2="680.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.23"
					y1="680.54"
					x2="686.05"
					y2="680.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="784.13"
					x2="694.27"
					y2="787.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="787.42"
					x2="696.33"
					y2="787.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.33"
					y1="787.42"
					x2="696.33"
					y2="784.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.33"
					y1="784.13"
					x2="694.27"
					y2="784.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.33"
					y1="680.54"
					x2="696.33"
					y2="677.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.33"
					y1="677.25"
					x2="694.27"
					y2="677.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="677.25"
					x2="694.27"
					y2="680.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="680.54"
					x2="696.33"
					y2="680.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="687.69 781.66 687.69 784.95 694.27 784.95 694.27 781.66 687.69 781.66"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="687.69 679.72 687.69 683 694.27 683 694.27 679.72 687.69 679.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="694.27 733.98 694.27 683 691.39 683 691.39 733.98 694.27 733.98"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="691.39 761.93 691.39 710.96 688.52 710.96 688.52 761.93 691.39 761.93"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="694.27"
					y1="784.95"
					x2="694.27"
					y2="785.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.69"
					y1="784.95"
					x2="687.69"
					y2="785.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="785.36"
					x2="687.69"
					y2="785.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="679.72"
					x2="694.27"
					y2="679.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.69"
					y1="679.72"
					x2="687.69"
					y2="679.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="679.31"
					x2="687.69"
					y2="679.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.69"
					y1="781.66"
					x2="694.27"
					y2="781.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="781.66"
					x2="694.27"
					y2="784.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="784.95"
					x2="687.69"
					y2="784.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.69"
					y1="784.95"
					x2="687.69"
					y2="781.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.69"
					y1="679.72"
					x2="694.27"
					y2="679.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="679.72"
					x2="694.27"
					y2="683"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="683"
					x2="687.69"
					y2="683"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.69"
					y1="683"
					x2="687.69"
					y2="679.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="733.98"
					x2="691.39"
					y2="733.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.39"
					y1="733.98"
					x2="691.39"
					y2="683"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.39"
					y1="683"
					x2="694.27"
					y2="683"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="683"
					x2="694.27"
					y2="733.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.39"
					y1="761.93"
					x2="688.52"
					y2="761.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.52"
					y1="761.93"
					x2="688.52"
					y2="710.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.52"
					y1="710.96"
					x2="691.39"
					y2="710.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.39"
					y1="710.96"
					x2="691.39"
					y2="761.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="785.36"
					x2="687.69"
					y2="785.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="785.36"
					x2="687.69"
					y2="785.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="687.69"
					y1="785.36"
					x2="686.05"
					y2="785.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="785.36"
					x2="694.27"
					y2="787.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="687.69"
					y1="785.36"
					x2="686.05"
					y2="785.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="686.05"
					y1="785.36"
					x2="686.05"
					y2="787.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="686.05"
					y1="785.36"
					x2="686.05"
					y2="787.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="679.31"
					x2="687.69"
					y2="679.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="679.31"
					x2="687.69"
					y2="679.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="687.69"
					y1="679.31"
					x2="686.05"
					y2="679.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="694.27"
					y1="679.31"
					x2="694.27"
					y2="677.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="687.69"
					y1="679.31"
					x2="686.05"
					y2="679.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="686.05"
					y1="679.31"
					x2="686.05"
					y2="677.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="686.05"
					y1="679.31"
					x2="686.05"
					y2="677.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="638.8"
					y1="576.31"
					x2="638.8"
					y2="562.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="638.8"
					y1="562.22"
					x2="431.04"
					y2="562.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="686.05"
					y1="659.32"
					x2="644.96"
					y2="659.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="644.96"
					y1="605.55"
					x2="686.05"
					y2="605.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="474.26"
					y1="594.18"
					x2="474.26"
					y2="591.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="482.48"
					y1="594.18"
					x2="482.48"
					y2="591.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="482.48"
					y1="594.18"
					x2="474.26"
					y2="594.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="474.26"
					y1="646.8"
					x2="474.26"
					y2="649.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="482.48"
					y1="646.8"
					x2="482.48"
					y2="649.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="482.48"
					y1="646.8"
					x2="474.26"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="474.26"
					y1="676.86"
					x2="474.26"
					y2="704.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="473.44 645.97 473.44 649.26 474.26 649.26 474.26 645.97 473.44 645.97"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="474.26 595 474.26 591.71 473.44 591.71 473.44 595 474.26 595"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="482.48 645.97 482.48 649.26 483.3 649.26 483.3 645.97 482.48 645.97"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="483.3 595 483.3 591.71 482.48 591.71 482.48 595 483.3 595"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="473.44"
					y1="645.97"
					x2="473.44"
					y2="649.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.44"
					y1="649.26"
					x2="474.26"
					y2="649.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="649.26"
					x2="474.26"
					y2="645.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="645.97"
					x2="473.44"
					y2="645.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="595"
					x2="474.26"
					y2="591.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="591.71"
					x2="473.44"
					y2="591.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.44"
					y1="591.71"
					x2="473.44"
					y2="595"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.44"
					y1="595"
					x2="474.26"
					y2="595"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.48"
					y1="645.97"
					x2="482.48"
					y2="649.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.48"
					y1="649.26"
					x2="483.3"
					y2="649.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.3"
					y1="649.26"
					x2="483.3"
					y2="645.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.3"
					y1="645.97"
					x2="482.48"
					y2="645.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.3"
					y1="595"
					x2="483.3"
					y2="591.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.3"
					y1="591.71"
					x2="482.48"
					y2="591.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.48"
					y1="591.71"
					x2="482.48"
					y2="595"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.48"
					y1="595"
					x2="483.3"
					y2="595"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="474.26 645.15 474.26 646.38 482.48 646.38 482.48 645.15 474.26 645.15"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="474.26 594.59 474.26 595.82 482.48 595.82 482.48 594.59 474.26 594.59"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="517.36 630.7 482.48 595.82 480.45 597.86 515.33 632.74 517.36 630.7"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="482.48"
					y1="646.38"
					x2="482.48"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="646.38"
					x2="474.26"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.48"
					y1="646.8"
					x2="474.26"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.48"
					y1="594.59"
					x2="482.48"
					y2="594.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="594.59"
					x2="474.26"
					y2="594.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.48"
					y1="594.18"
					x2="474.26"
					y2="594.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="645.15"
					x2="482.48"
					y2="645.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.48"
					y1="645.15"
					x2="482.48"
					y2="646.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.48"
					y1="646.38"
					x2="474.26"
					y2="646.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="646.38"
					x2="474.26"
					y2="645.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="594.59"
					x2="482.48"
					y2="594.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.48"
					y1="594.59"
					x2="482.48"
					y2="595.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.48"
					y1="595.82"
					x2="474.26"
					y2="595.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.26"
					y1="595.82"
					x2="474.26"
					y2="594.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.36"
					y1="630.7"
					x2="515.33"
					y2="632.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.33"
					y1="632.74"
					x2="480.45"
					y2="597.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.45"
					y1="597.86"
					x2="482.48"
					y2="595.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.48"
					y1="595.82"
					x2="517.36"
					y2="630.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.48"
					y1="646.8"
					x2="474.26"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="482.48"
					y1="646.8"
					x2="474.26"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="482.48"
					y1="646.8"
					x2="482.48"
					y2="649.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="482.48"
					y1="646.8"
					x2="482.48"
					y2="649.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="474.26"
					y1="646.8"
					x2="474.26"
					y2="649.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="474.26"
					y1="646.8"
					x2="474.26"
					y2="649.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="482.48"
					y1="594.18"
					x2="474.26"
					y2="594.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="482.48"
					y1="594.18"
					x2="474.26"
					y2="594.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="482.48"
					y1="594.18"
					x2="482.48"
					y2="591.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="482.48"
					y1="594.18"
					x2="482.48"
					y2="591.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="474.26"
					y1="594.18"
					x2="474.26"
					y2="591.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="474.26"
					y1="594.18"
					x2="474.26"
					y2="591.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="433.81"
					y1="786.96"
					x2="433.81"
					y2="789.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="432.16"
					y1="786.96"
					x2="433.81"
					y2="786.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="425.59"
					y1="786.96"
					x2="425.59"
					y2="789.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="425.59"
					y1="786.96"
					x2="432.16"
					y2="786.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="433.81"
					y1="691.15"
					x2="433.81"
					y2="689.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="432.16"
					y1="691.15"
					x2="433.81"
					y2="691.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="425.59"
					y1="691.15"
					x2="425.59"
					y2="689.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="425.59"
					y1="691.15"
					x2="432.16"
					y2="691.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="433.81"
					y1="801.25"
					x2="433.81"
					y2="786.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="432.16 692.38 433.81 692.38 433.81 691.56 432.16 691.56 432.16 692.38"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="434.63 692.38 434.63 689.09 433.81 689.09 433.81 692.38 434.63 692.38"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="432.16 786.55 433.81 786.55 433.81 785.73 432.16 785.73 432.16 786.55"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="433.81 785.73 433.81 789.01 434.63 789.01 434.63 785.73 433.81 785.73"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="425.59 692.38 425.59 689.09 423.53 689.09 423.53 692.38 425.59 692.38"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="423.53 785.73 423.53 789.01 425.59 789.01 425.59 785.73 423.53 785.73"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="432.16"
					y1="692.38"
					x2="433.81"
					y2="692.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.81"
					y1="692.38"
					x2="433.81"
					y2="691.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.81"
					y1="691.56"
					x2="432.16"
					y2="691.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.16"
					y1="691.56"
					x2="432.16"
					y2="692.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.63"
					y1="692.38"
					x2="434.63"
					y2="689.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.63"
					y1="689.09"
					x2="433.81"
					y2="689.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.81"
					y1="689.09"
					x2="433.81"
					y2="692.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.81"
					y1="692.38"
					x2="434.63"
					y2="692.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.16"
					y1="786.55"
					x2="433.81"
					y2="786.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.81"
					y1="786.55"
					x2="433.81"
					y2="785.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.81"
					y1="785.73"
					x2="432.16"
					y2="785.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.16"
					y1="785.73"
					x2="432.16"
					y2="786.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.81"
					y1="785.73"
					x2="433.81"
					y2="789.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.81"
					y1="789.01"
					x2="434.63"
					y2="789.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.63"
					y1="789.01"
					x2="434.63"
					y2="785.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.63"
					y1="785.73"
					x2="433.81"
					y2="785.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.59"
					y1="692.38"
					x2="425.59"
					y2="689.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.59"
					y1="689.09"
					x2="423.53"
					y2="689.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.53"
					y1="689.09"
					x2="423.53"
					y2="692.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.53"
					y1="692.38"
					x2="425.59"
					y2="692.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.53"
					y1="785.73"
					x2="423.53"
					y2="789.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.53"
					y1="789.01"
					x2="425.59"
					y2="789.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.59"
					y1="789.01"
					x2="425.59"
					y2="785.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.59"
					y1="785.73"
					x2="423.53"
					y2="785.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="432.16 694.85 432.16 691.56 425.59 691.56 425.59 694.85 432.16 694.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="432.16 786.55 432.16 783.26 425.59 783.26 425.59 786.55 432.16 786.55"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="425.59 737.41 425.59 783.26 428.46 783.26 428.46 737.41 425.59 737.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="428.46 714.58 428.46 760.43 431.34 760.43 431.34 714.58 428.46 714.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="425.59"
					y1="691.56"
					x2="425.59"
					y2="691.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.16"
					y1="691.56"
					x2="432.16"
					y2="691.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.59"
					y1="691.15"
					x2="432.16"
					y2="691.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.59"
					y1="786.55"
					x2="425.59"
					y2="786.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.16"
					y1="786.55"
					x2="432.16"
					y2="786.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.59"
					y1="786.96"
					x2="432.16"
					y2="786.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.16"
					y1="694.85"
					x2="425.59"
					y2="694.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.59"
					y1="694.85"
					x2="425.59"
					y2="691.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.59"
					y1="691.56"
					x2="432.16"
					y2="691.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.16"
					y1="691.56"
					x2="432.16"
					y2="694.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.16"
					y1="786.55"
					x2="425.59"
					y2="786.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.59"
					y1="786.55"
					x2="425.59"
					y2="783.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.59"
					y1="783.26"
					x2="432.16"
					y2="783.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.16"
					y1="783.26"
					x2="432.16"
					y2="786.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.59"
					y1="737.41"
					x2="428.46"
					y2="737.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.46"
					y1="737.41"
					x2="428.46"
					y2="783.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.46"
					y1="783.26"
					x2="425.59"
					y2="783.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.59"
					y1="783.26"
					x2="425.59"
					y2="737.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.46"
					y1="714.58"
					x2="431.34"
					y2="714.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.34"
					y1="714.58"
					x2="431.34"
					y2="760.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.34"
					y1="760.43"
					x2="428.46"
					y2="760.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.46"
					y1="760.43"
					x2="428.46"
					y2="714.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.59"
					y1="691.15"
					x2="432.16"
					y2="691.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="425.59"
					y1="691.15"
					x2="432.16"
					y2="691.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="432.16"
					y1="691.15"
					x2="433.81"
					y2="691.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="425.59"
					y1="691.15"
					x2="425.59"
					y2="689.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="432.16"
					y1="691.15"
					x2="433.81"
					y2="691.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="433.81"
					y1="691.15"
					x2="433.81"
					y2="689.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="433.81"
					y1="691.15"
					x2="433.81"
					y2="689.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="425.59"
					y1="786.96"
					x2="432.16"
					y2="786.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="425.59"
					y1="786.96"
					x2="432.16"
					y2="786.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="432.16"
					y1="786.96"
					x2="433.81"
					y2="786.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="425.59"
					y1="786.96"
					x2="425.59"
					y2="789.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="432.16"
					y1="786.96"
					x2="433.81"
					y2="786.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="433.81"
					y1="786.96"
					x2="433.81"
					y2="789.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="433.81"
					y1="786.96"
					x2="433.81"
					y2="789.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="605.9"
					y1="411.69"
					x2="603.43"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="605.9"
					y1="403.47"
					x2="603.43"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="605.9"
					y1="403.47"
					x2="605.9"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="658.51"
					y1="411.69"
					x2="660.98"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="658.51"
					y1="403.47"
					x2="660.98"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="658.51"
					y1="403.47"
					x2="658.51"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="715.83"
					y1="411.69"
					x2="713.78"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="715.83"
					y1="410.04"
					x2="715.83"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="715.83"
					y1="403.47"
					x2="713.78"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="715.83"
					y1="403.47"
					x2="715.83"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="813.44"
					y1="411.69"
					x2="815.49"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="813.44"
					y1="410.04"
					x2="813.44"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="813.44"
					y1="403.47"
					x2="815.49"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="813.44"
					y1="403.47"
					x2="813.44"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="657.69 412.51 660.98 412.51 660.98 411.69 657.69 411.69 657.69 412.51"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="606.72 411.69 603.43 411.69 603.43 412.51 606.72 412.51 606.72 411.69"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="657.69 403.47 660.98 403.47 660.98 402.64 657.69 402.64 657.69 403.47"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="606.72 402.64 603.43 402.64 603.43 403.47 606.72 403.47 606.72 402.64"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="657.69"
					y1="412.51"
					x2="660.98"
					y2="412.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.98"
					y1="412.51"
					x2="660.98"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.98"
					y1="411.69"
					x2="657.69"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.69"
					y1="411.69"
					x2="657.69"
					y2="412.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.72"
					y1="411.69"
					x2="603.43"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="603.43"
					y1="411.69"
					x2="603.43"
					y2="412.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="603.43"
					y1="412.51"
					x2="606.72"
					y2="412.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.72"
					y1="412.51"
					x2="606.72"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.69"
					y1="403.47"
					x2="660.98"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.98"
					y1="403.47"
					x2="660.98"
					y2="402.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.98"
					y1="402.64"
					x2="657.69"
					y2="402.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.69"
					y1="402.64"
					x2="657.69"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.72"
					y1="402.64"
					x2="603.43"
					y2="402.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="603.43"
					y1="402.64"
					x2="603.43"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="603.43"
					y1="403.47"
					x2="606.72"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.72"
					y1="403.47"
					x2="606.72"
					y2="402.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="656.87 411.69 658.1 411.69 658.1 403.47 656.87 403.47 656.87 411.69"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="606.3 411.69 607.54 411.69 607.54 403.47 606.3 403.47 606.3 411.69"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="642.42 368.58 607.54 403.47 609.57 405.5 644.45 370.62 642.42 368.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="658.1"
					y1="403.47"
					x2="658.51"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.1"
					y1="411.69"
					x2="658.51"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.51"
					y1="403.47"
					x2="658.51"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.3"
					y1="403.47"
					x2="605.9"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.3"
					y1="411.69"
					x2="605.9"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.9"
					y1="403.47"
					x2="605.9"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.87"
					y1="411.69"
					x2="656.87"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.87"
					y1="403.47"
					x2="658.1"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.1"
					y1="403.47"
					x2="658.1"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.1"
					y1="411.69"
					x2="656.87"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.3"
					y1="411.69"
					x2="606.3"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.3"
					y1="403.47"
					x2="607.54"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="607.54"
					y1="403.47"
					x2="607.54"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="607.54"
					y1="411.69"
					x2="606.3"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.42"
					y1="368.58"
					x2="644.45"
					y2="370.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.45"
					y1="370.62"
					x2="609.57"
					y2="405.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.57"
					y1="405.5"
					x2="607.54"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="607.54"
					y1="403.47"
					x2="642.42"
					y2="368.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.51"
					y1="403.47"
					x2="658.51"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="658.51"
					y1="403.47"
					x2="658.51"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="658.51"
					y1="403.47"
					x2="660.98"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="658.51"
					y1="403.47"
					x2="660.98"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="658.51"
					y1="411.69"
					x2="660.98"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="658.51"
					y1="411.69"
					x2="660.98"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="605.9"
					y1="403.47"
					x2="605.9"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="605.9"
					y1="403.47"
					x2="605.9"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="605.9"
					y1="403.47"
					x2="603.43"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="605.9"
					y1="403.47"
					x2="603.43"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="605.9"
					y1="411.69"
					x2="603.43"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="605.9"
					y1="411.69"
					x2="603.43"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="812.21 410.04 812.21 411.69 813.03 411.69 813.03 410.04 812.21 410.04"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="812.21 412.51 815.49 412.51 815.49 411.69 812.21 411.69 812.21 412.51"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="716.24 410.04 716.24 411.69 717.07 411.69 717.07 410.04 716.24 410.04"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="717.07 411.69 713.78 411.69 713.78 412.51 717.07 412.51 717.07 411.69"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="812.21 403.47 815.49 403.47 815.49 401.41 812.21 401.41 812.21 403.47"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="717.07 401.41 713.78 401.41 713.78 403.47 717.07 403.47 717.07 401.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="812.21"
					y1="410.04"
					x2="812.21"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.21"
					y1="411.69"
					x2="813.03"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="813.03"
					y1="411.69"
					x2="813.03"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="813.03"
					y1="410.04"
					x2="812.21"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.21"
					y1="412.51"
					x2="815.49"
					y2="412.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="815.49"
					y1="412.51"
					x2="815.49"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="815.49"
					y1="411.69"
					x2="812.21"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.21"
					y1="411.69"
					x2="812.21"
					y2="412.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.24"
					y1="410.04"
					x2="716.24"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.24"
					y1="411.69"
					x2="717.07"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.07"
					y1="411.69"
					x2="717.07"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.07"
					y1="410.04"
					x2="716.24"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.07"
					y1="411.69"
					x2="713.78"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.78"
					y1="411.69"
					x2="713.78"
					y2="412.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.78"
					y1="412.51"
					x2="717.07"
					y2="412.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.07"
					y1="412.51"
					x2="717.07"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.21"
					y1="403.47"
					x2="815.49"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="815.49"
					y1="403.47"
					x2="815.49"
					y2="401.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="815.49"
					y1="401.41"
					x2="812.21"
					y2="401.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.21"
					y1="401.41"
					x2="812.21"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.07"
					y1="401.41"
					x2="713.78"
					y2="401.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.78"
					y1="401.41"
					x2="713.78"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.78"
					y1="403.47"
					x2="717.07"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.07"
					y1="403.47"
					x2="717.07"
					y2="401.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="809.74 410.04 813.03 410.04 813.03 403.47 809.74 403.47 809.74 410.04"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="716.24 410.04 719.53 410.04 719.53 403.47 716.24 403.47 716.24 410.04"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="766.28 403.47 719.53 403.47 719.53 406.34 766.28 406.34 766.28 403.47"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="790.01 406.34 743.26 406.34 743.26 409.22 790.01 409.22 790.01 406.34"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="813.03"
					y1="403.47"
					x2="813.44"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="813.03"
					y1="410.04"
					x2="813.44"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="813.44"
					y1="403.47"
					x2="813.44"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.24"
					y1="403.47"
					x2="715.83"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.24"
					y1="410.04"
					x2="715.83"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.83"
					y1="403.47"
					x2="715.83"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="809.74"
					y1="410.04"
					x2="809.74"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="809.74"
					y1="403.47"
					x2="813.03"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="813.03"
					y1="403.47"
					x2="813.03"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="813.03"
					y1="410.04"
					x2="809.74"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.24"
					y1="410.04"
					x2="716.24"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.24"
					y1="403.47"
					x2="719.53"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.53"
					y1="403.47"
					x2="719.53"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.53"
					y1="410.04"
					x2="716.24"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.28"
					y1="403.47"
					x2="766.28"
					y2="406.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.28"
					y1="406.34"
					x2="719.53"
					y2="406.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.53"
					y1="406.34"
					x2="719.53"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.53"
					y1="403.47"
					x2="766.28"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.01"
					y1="406.34"
					x2="790.01"
					y2="409.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.01"
					y1="409.22"
					x2="743.26"
					y2="409.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.26"
					y1="409.22"
					x2="743.26"
					y2="406.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.26"
					y1="406.34"
					x2="790.01"
					y2="406.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="813.44"
					y1="403.47"
					x2="813.44"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="813.44"
					y1="403.47"
					x2="813.44"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="813.44"
					y1="410.04"
					x2="813.44"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="813.44"
					y1="403.47"
					x2="815.49"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="813.44"
					y1="410.04"
					x2="813.44"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="813.44"
					y1="411.69"
					x2="815.49"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="813.44"
					y1="411.69"
					x2="815.49"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="715.83"
					y1="403.47"
					x2="715.83"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="715.83"
					y1="403.47"
					x2="715.83"
					y2="410.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="715.83"
					y1="410.04"
					x2="715.83"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="715.83"
					y1="403.47"
					x2="713.78"
					y2="403.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="715.83"
					y1="410.04"
					x2="715.83"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="715.83"
					y1="411.69"
					x2="713.78"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="715.83"
					y1="411.69"
					x2="713.78"
					y2="411.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="645.22"
					y1="239.18"
					x2="645.22"
					y2="176.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="825.52"
					y1="457.02"
					x2="828.24"
					y2="457.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="817.3"
					y1="463.1"
					x2="817.3"
					y2="460.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="825.52"
					y1="463.1"
					x2="825.52"
					y2="460.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="825.52"
					y1="463.1"
					x2="817.3"
					y2="463.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="817.3"
					y1="515.72"
					x2="817.3"
					y2="518.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="825.52"
					y1="515.72"
					x2="825.52"
					y2="518.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="825.52"
					y1="515.72"
					x2="817.3"
					y2="515.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="825.52"
					y1="463.1"
					x2="825.52"
					y2="457.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="817.3"
					y1="457.02"
					x2="817.3"
					y2="463.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="816.48 514.89 816.48 518.18 817.3 518.18 817.3 514.89 816.48 514.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="817.3 463.92 817.3 460.63 816.48 460.63 816.48 463.92 817.3 463.92"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="825.52 514.89 825.52 518.18 826.35 518.18 826.35 514.89 825.52 514.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="826.35 463.92 826.35 460.63 825.52 460.63 825.52 463.92 826.35 463.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="816.48"
					y1="514.89"
					x2="816.48"
					y2="518.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="816.48"
					y1="518.18"
					x2="817.3"
					y2="518.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.3"
					y1="518.18"
					x2="817.3"
					y2="514.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.3"
					y1="514.89"
					x2="816.48"
					y2="514.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.3"
					y1="463.92"
					x2="817.3"
					y2="460.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.3"
					y1="460.63"
					x2="816.48"
					y2="460.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="816.48"
					y1="460.63"
					x2="816.48"
					y2="463.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="816.48"
					y1="463.92"
					x2="817.3"
					y2="463.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.52"
					y1="514.89"
					x2="825.52"
					y2="518.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.52"
					y1="518.18"
					x2="826.35"
					y2="518.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="826.35"
					y1="518.18"
					x2="826.35"
					y2="514.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="826.35"
					y1="514.89"
					x2="825.52"
					y2="514.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="826.35"
					y1="463.92"
					x2="826.35"
					y2="460.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="826.35"
					y1="460.63"
					x2="825.52"
					y2="460.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.52"
					y1="460.63"
					x2="825.52"
					y2="463.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.52"
					y1="463.92"
					x2="826.35"
					y2="463.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="817.3 514.07 817.3 515.3 825.52 515.3 825.52 514.07 817.3 514.07"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="817.3 463.51 817.3 464.74 825.52 464.74 825.52 463.51 817.3 463.51"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="860.4 499.62 825.52 464.74 823.49 466.78 858.37 501.66 860.4 499.62"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="825.52"
					y1="515.3"
					x2="825.52"
					y2="515.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.3"
					y1="515.3"
					x2="817.3"
					y2="515.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.52"
					y1="515.72"
					x2="817.3"
					y2="515.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.52"
					y1="463.51"
					x2="825.52"
					y2="463.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.3"
					y1="463.51"
					x2="817.3"
					y2="463.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.52"
					y1="463.1"
					x2="817.3"
					y2="463.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.3"
					y1="514.07"
					x2="825.52"
					y2="514.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.52"
					y1="514.07"
					x2="825.52"
					y2="515.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.52"
					y1="515.3"
					x2="817.3"
					y2="515.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.3"
					y1="515.3"
					x2="817.3"
					y2="514.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.3"
					y1="463.51"
					x2="825.52"
					y2="463.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.52"
					y1="463.51"
					x2="825.52"
					y2="464.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.52"
					y1="464.74"
					x2="817.3"
					y2="464.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.3"
					y1="464.74"
					x2="817.3"
					y2="463.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="860.4"
					y1="499.62"
					x2="858.37"
					y2="501.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="858.37"
					y1="501.66"
					x2="823.49"
					y2="466.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.49"
					y1="466.78"
					x2="825.52"
					y2="464.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.52"
					y1="464.74"
					x2="860.4"
					y2="499.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m858.31,501.6c-9.03,8.03-20.7,12.47-32.79,12.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.52"
					y1="515.72"
					x2="817.3"
					y2="515.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="825.52"
					y1="515.72"
					x2="817.3"
					y2="515.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="825.52"
					y1="515.72"
					x2="825.52"
					y2="518.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="825.52"
					y1="515.72"
					x2="825.52"
					y2="518.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="817.3"
					y1="515.72"
					x2="817.3"
					y2="518.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="817.3"
					y1="515.72"
					x2="817.3"
					y2="518.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="825.52"
					y1="463.1"
					x2="817.3"
					y2="463.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="825.52"
					y1="463.1"
					x2="817.3"
					y2="463.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="825.52"
					y1="463.1"
					x2="825.52"
					y2="460.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="825.52"
					y1="463.1"
					x2="825.52"
					y2="460.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="817.3"
					y1="463.1"
					x2="817.3"
					y2="460.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="817.3"
					y1="463.1"
					x2="817.3"
					y2="460.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="340.64 186.06 340.64 189.35 132.21 189.35 132.21 186.06 340.64 186.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="340.64"
					y1="186.06"
					x2="132.21"
					y2="186.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="132.21"
					y1="189.35"
					x2="340.64"
					y2="189.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="340.64"
					y1="189.35"
					x2="340.64"
					y2="186.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<polyline
					points="50 268.28 53.29 268.28 53.29 828.71 50 832 50 268.28"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="50"
					y1="268.28"
					x2="50"
					y2="832"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="53.29"
					y1="828.71"
					x2="53.29"
					y2="268.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<polyline
					points="50 832 53.29 828.71 211.55 828.71 211.55 832 50 832"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="50"
					y1="832"
					x2="211.55"
					y2="832"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="211.55"
					y1="832"
					x2="211.55"
					y2="828.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="211.55"
					y1="828.71"
					x2="53.29"
					y2="828.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<polyline
					points="132.21 186.06 132.21 189.35 123.38 189.85 114.65 191.33 106.15 193.78 97.97 197.17 90.22 201.45 83 206.57 76.41 212.47 70.51 219.07 65.39 226.28 61.1 234.03 57.72 242.21 55.27 250.71 53.78 259.44 53.29 268.28 50 268.28 50.52 259.07 52.06 249.98 54.61 241.12 58.14 232.6 62.6 224.54 67.94 217.02 74.08 210.14 80.95 204 88.47 198.66 96.54 194.2 105.06 190.68 113.92 188.12 123.01 186.58 132.21 186.06"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m50,268.28c0-45.41,36.81-82.21,82.21-82.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<path
					d="m53.29,268.28c0-43.59,35.34-78.93,78.93-78.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="561.92"
					y1="163.6"
					x2="561.92"
					y2="176.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="645.22"
					y1="176.75"
					x2="649.43"
					y2="176.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="649.43"
					y1="176.75"
					x2="649.43"
					y2="163.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="432.2"
					y1="176.75"
					x2="432.2"
					y2="163.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="224.71"
					y1="754.99"
					x2="211.55"
					y2="754.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="353.79"
					y1="466.34"
					x2="340.64"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="922"
					y1="611.19"
					x2="825.52"
					y2="611.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.52"
					y1="611.19"
					x2="825.52"
					y2="557.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.52"
					y1="557.42"
					x2="922"
					y2="557.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="915.95 563.79 915.95 604.12 831.98 604.12 831.98 563.79 915.95 563.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="915.95"
					y1="563.79"
					x2="915.95"
					y2="604.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="915.95"
					y1="604.12"
					x2="831.98"
					y2="604.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.98"
					y1="604.12"
					x2="831.98"
					y2="563.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.98"
					y1="563.79"
					x2="915.95"
					y2="563.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="907.7 584.31 907.73 583.94 907.81 583.59 907.95 583.26 908.13 582.97 908.36 582.71 908.62 582.5 908.91 582.35 909.22 582.25 909.54 582.22 909.86 582.25 910.17 582.35 910.47 582.5 910.73 582.71 910.95 582.97 911.14 583.26 911.28 583.59 911.36 583.94 911.38 584.31 911.36 584.67 911.28 585.02 911.14 585.35 910.95 585.65 910.73 585.9 910.47 586.11 910.17 586.26 909.86 586.36 909.54 586.39 909.22 586.36 908.91 586.26 908.62 586.11 908.36 585.9 908.13 585.65 907.95 585.35 907.81 585.02 907.73 584.67 907.7 584.31"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="907.7"
					y1="584.31"
					x2="907.73"
					y2="583.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.73"
					y1="583.94"
					x2="907.81"
					y2="583.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.81"
					y1="583.59"
					x2="907.95"
					y2="583.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.95"
					y1="583.26"
					x2="908.13"
					y2="582.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.13"
					y1="582.97"
					x2="908.36"
					y2="582.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.36"
					y1="582.71"
					x2="908.62"
					y2="582.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.62"
					y1="582.5"
					x2="908.91"
					y2="582.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.91"
					y1="582.35"
					x2="909.22"
					y2="582.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.22"
					y1="582.25"
					x2="909.54"
					y2="582.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.54"
					y1="582.22"
					x2="909.86"
					y2="582.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.86"
					y1="582.25"
					x2="910.17"
					y2="582.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.17"
					y1="582.35"
					x2="910.47"
					y2="582.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.47"
					y1="582.5"
					x2="910.73"
					y2="582.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.73"
					y1="582.71"
					x2="910.95"
					y2="582.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.95"
					y1="582.97"
					x2="911.14"
					y2="583.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.14"
					y1="583.26"
					x2="911.28"
					y2="583.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.28"
					y1="583.59"
					x2="911.36"
					y2="583.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.36"
					y1="583.94"
					x2="911.38"
					y2="584.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.38"
					y1="584.31"
					x2="911.36"
					y2="584.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.36"
					y1="584.67"
					x2="911.28"
					y2="585.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.28"
					y1="585.02"
					x2="911.14"
					y2="585.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.14"
					y1="585.35"
					x2="910.95"
					y2="585.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.95"
					y1="585.65"
					x2="910.73"
					y2="585.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.73"
					y1="585.9"
					x2="910.47"
					y2="586.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.47"
					y1="586.11"
					x2="910.17"
					y2="586.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.17"
					y1="586.26"
					x2="909.86"
					y2="586.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.86"
					y1="586.36"
					x2="909.54"
					y2="586.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.54"
					y1="586.39"
					x2="909.22"
					y2="586.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.22"
					y1="586.36"
					x2="908.91"
					y2="586.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.91"
					y1="586.26"
					x2="908.62"
					y2="586.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.62"
					y1="586.11"
					x2="908.36"
					y2="585.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.36"
					y1="585.9"
					x2="908.13"
					y2="585.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.13"
					y1="585.65"
					x2="907.95"
					y2="585.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.95"
					y1="585.35"
					x2="907.81"
					y2="585.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.81"
					y1="585.02"
					x2="907.73"
					y2="584.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.73"
					y1="584.67"
					x2="907.7"
					y2="584.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="918.11 586.11 915.44 585.82 915.23 585.78 915.03 585.7 914.84 585.58 911.47 585.1 911.35 585.08 911.24 585.03 911.14 584.95 911.05 584.86 910.97 584.76 910.91 584.64 910.87 584.51 910.85 584.38 910.85 584.24 910.87 584.1 910.91 583.98 910.97 583.85 911.05 583.75 911.14 583.66 911.24 583.59 911.35 583.53 911.47 583.51 914.84 583.03 915.03 582.92 915.23 582.84 915.44 582.8 918.11 582.51 918.39 582.53 918.65 582.62 918.9 582.75 919.13 582.93 919.33 583.15 919.49 583.41 919.6 583.69 919.67 583.99 919.7 584.31 919.67 584.62 919.6 584.92 919.49 585.2 919.33 585.46 919.13 585.68 918.9 585.86 918.65 586 918.39 586.08 918.11 586.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="918.11"
					y1="586.11"
					x2="915.44"
					y2="585.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="914.84"
					y1="585.58"
					x2="911.47"
					y2="585.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.47"
					y1="583.51"
					x2="914.84"
					y2="583.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="915.44"
					y1="582.8"
					x2="918.11"
					y2="582.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.53"
					y1="583.33"
					x2="915.58"
					y2="583.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="915.58"
					y1="585.29"
					x2="916.53"
					y2="585.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.53"
					y1="585.29"
					x2="916.53"
					y2="583.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m915.44,585.82c-.21-.02-.42-.1-.6-.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m911.47,585.1c-.36-.05-.62-.39-.62-.8s.27-.75.62-.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m914.84,583.03c.18-.13.39-.21.6-.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m918.11,582.51c.88,0,1.59.81,1.59,1.8s-.71,1.8-1.59,1.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m915.58,585.29c-.48,0-.87-.44-.87-.98s.39-.98.87-.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m914.84,585.58c-.38-.28-.62-.76-.62-1.28s.23-1,.62-1.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="636.73 584.53 585.44 584.53 585.44 685.42 636.73 685.42 636.73 584.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="636.73"
					y1="685.42"
					x2="636.73"
					y2="584.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="585.44"
					y1="685.42"
					x2="636.73"
					y2="685.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="585.44"
					y1="584.53"
					x2="585.44"
					y2="685.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="636.73"
					y1="584.53"
					x2="585.44"
					y2="584.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.5"
					y1="682.19"
					x2="633.5"
					y2="587.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.5"
					y1="587.77"
					x2="588.67"
					y2="587.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588.67"
					y1="587.77"
					x2="588.67"
					y2="682.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588.67"
					y1="682.19"
					x2="633.5"
					y2="682.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.5"
					y1="682.19"
					x2="613.16"
					y2="639.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588.67"
					y1="682.19"
					x2="609.02"
					y2="639.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.5"
					y1="587.77"
					x2="613.16"
					y2="630.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588.67"
					y1="587.77"
					x2="609.02"
					y2="630.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.32"
					y1="634.98"
					x2="607.85"
					y2="634.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.09"
					y1="631.74"
					x2="611.09"
					y2="638.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m616.26,634.98c0-2.86-2.32-5.18-5.18-5.18s-5.18,2.32-5.18,5.18,2.32,5.18,5.18,5.18,5.18-2.32,5.18-5.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m614.32,634.98c0-1.79-1.45-3.24-3.24-3.24s-3.24,1.45-3.24,3.24,1.45,3.24,3.24,3.24,3.24-1.45,3.24-3.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="611.09 685.42 616.14 678.56 606.03 678.56 611.09 685.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="606.03"
					y1="678.56"
					x2="611.09"
					y2="685.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.14"
					y1="678.56"
					x2="606.03"
					y2="678.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.09"
					y1="685.42"
					x2="616.14"
					y2="678.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.09"
					y1="676.99"
					x2="611.09"
					y2="672.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.09"
					y1="678.56"
					x2="606.03"
					y2="678.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.03"
					y1="678.56"
					x2="611.09"
					y2="685.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.09"
					y1="678.56"
					x2="616.14"
					y2="678.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.14"
					y1="678.56"
					x2="611.09"
					y2="685.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.59"
					y1="677.12"
					x2="607.5"
					y2="673.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="612.57"
					y1="677.12"
					x2="614.67"
					y2="673.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="903.97 515.37 903.97 557.42 936.84 557.42 936.84 515.37 903.97 515.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="903.97"
					y1="515.37"
					x2="903.97"
					y2="557.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="936.84"
					y1="515.37"
					x2="936.84"
					y2="557.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.97"
					y1="557.42"
					x2="936.84"
					y2="557.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.97"
					y1="515.37"
					x2="936.84"
					y2="515.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.55"
					y1="515.37"
					x2="935.55"
					y2="557.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.77"
					y1="519.95"
					x2="911.77"
					y2="552.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.77"
					y1="552.84"
					x2="931.5"
					y2="552.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="931.5"
					y1="552.84"
					x2="931.5"
					y2="519.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="931.5"
					y1="519.95"
					x2="911.77"
					y2="519.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.48"
					y1="518.66"
					x2="910.48"
					y2="554.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.48"
					y1="554.13"
					x2="932.8"
					y2="554.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="932.8"
					y1="554.13"
					x2="932.8"
					y2="518.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="932.8"
					y1="518.66"
					x2="910.48"
					y2="518.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m928.99,536.39c0-1.07-.87-1.94-1.94-1.94s-1.94.87-1.94,1.94.87,1.94,1.94,1.94,1.94-.87,1.94-1.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="935.06 534.78 932.35 535.04 931.73 535.25 928.3 535.68 927.85 535.92 927.67 536.39 927.85 536.88 928.3 537.11 931.73 537.54 932.35 537.75 935.06 538.01 936.21 537.54 936.68 536.39 936.21 535.25 935.06 534.78"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m935.06,534.78c.89,0,1.62.73,1.62,1.62s-.72,1.62-1.62,1.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="932.35"
					y1="537.75"
					x2="935.06"
					y2="538.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m932.35,537.75c-.22-.02-.43-.09-.62-.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="928.3"
					y1="537.11"
					x2="931.73"
					y2="537.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m928.3,537.11c-.36-.04-.63-.35-.63-.72s.27-.67.63-.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="931.73"
					y1="535.25"
					x2="928.3"
					y2="535.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m931.73,535.25c.19-.12.4-.19.62-.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.06"
					y1="534.78"
					x2="932.35"
					y2="535.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="933.45"
					y1="537.28"
					x2="932.49"
					y2="537.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="932.49"
					y1="535.51"
					x2="933.45"
					y2="535.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="933.45"
					y1="535.51"
					x2="933.45"
					y2="537.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m932.49,537.28c-.48,0-.88-.39-.88-.88s.39-.88.88-.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m931.73,537.54c-.39-.25-.63-.68-.63-1.15s.24-.89.63-1.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="893.66 493.7 897.41 497.09 902.3 498.96 908.45 499.6 914.47 498.21 919.81 498.66 924.67 500.89 927.9 502.63 929.96 502.96 930.35 502.96 933.6 501.9 935.95 499.42 936.84 496.12 936.84 479.04 936.32 476.49 934.97 474.26 936.42 474.26 936.42 472.93 933.23 472.93 932.03 472.46 929 472.3 926.14 473.34 924.75 474.23 919.82 476.48 914.43 476.93 908.42 475.55 902.3 476.2 897.41 478.06 893.66 481.47 892.35 484.4 891.89 487.58 892.35 490.76 893.66 493.7"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="921.66"
					y1="481.49"
					x2="921.66"
					y2="493.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="936.84"
					y1="496.12"
					x2="936.84"
					y2="487.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="936.22"
					y1="496.12"
					x2="936.22"
					y2="487.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="936.84"
					y1="479.04"
					x2="936.84"
					y2="487.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="936.22"
					y1="479.04"
					x2="936.22"
					y2="487.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.66"
					y1="493.35"
					x2="923.93"
					y2="493.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.93"
					y1="493.35"
					x2="923.93"
					y2="491.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.93"
					y1="491.47"
					x2="921.66"
					y2="491.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.66"
					y1="481.81"
					x2="923.93"
					y2="481.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.93"
					y1="481.81"
					x2="923.93"
					y2="483.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.93"
					y1="483.69"
					x2="921.66"
					y2="483.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.77"
					y1="474.26"
					x2="936.42"
					y2="474.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.77"
					y1="472.93"
					x2="936.42"
					y2="472.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="936.42"
					y1="472.93"
					x2="936.42"
					y2="474.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.77"
					y1="472.93"
					x2="930.77"
					y2="474.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.89"
					y1="487.58"
					x2="892.13"
					y2="489.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.13"
					y1="489.62"
					x2="892.65"
					y2="491.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.65"
					y1="491.59"
					x2="893.66"
					y2="493.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="893.66"
					y1="493.7"
					x2="895.32"
					y2="495.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.32"
					y1="495.63"
					x2="897.41"
					y2="497.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="897.41"
					y1="497.09"
					x2="899.78"
					y2="498.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="899.78"
					y1="498.17"
					x2="902.3"
					y2="498.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="902.3"
					y1="498.96"
					x2="906.37"
					y2="499.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.37"
					y1="499.67"
					x2="908.42"
					y2="499.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.42"
					y1="499.71"
					x2="910.47"
					y2="499.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.47"
					y1="499.47"
					x2="913.65"
					y2="498.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="913.65"
					y1="498.55"
					x2="916.72"
					y2="497.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.72"
					y1="497.11"
					x2="919.46"
					y2="495.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="919.46"
					y1="495.4"
					x2="921.66"
					y2="493.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="914.47"
					y1="498.21"
					x2="917.32"
					y2="498.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="917.32"
					y1="498.23"
					x2="920.09"
					y2="498.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="920.09"
					y1="498.7"
					x2="923.07"
					y2="499.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.07"
					y1="499.88"
					x2="927.45"
					y2="502.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="927.45"
					y1="502.46"
					x2="929.62"
					y2="502.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="929.62"
					y1="502.95"
					x2="931.79"
					y2="502.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="931.79"
					y1="502.77"
					x2="933.77"
					y2="501.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="933.77"
					y1="501.92"
					x2="935.35"
					y2="500.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.35"
					y1="500.43"
					x2="936.16"
					y2="498.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="936.16"
					y1="498.97"
					x2="936.61"
					y2="497.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="936.61"
					y1="497.58"
					x2="936.84"
					y2="496.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="936.22"
					y1="496.12"
					x2="935.75"
					y2="498.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.75"
					y1="498.11"
					x2="934.75"
					y2="499.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.75"
					y1="499.3"
					x2="933.35"
					y2="500.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="933.35"
					y1="500.05"
					x2="931.52"
					y2="500.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="931.52"
					y1="500.4"
					x2="929.63"
					y2="500.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="929.63"
					y1="500.48"
					x2="928.69"
					y2="500.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="928.69"
					y1="500.47"
					x2="927.95"
					y2="500.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="927.95"
					y1="500.07"
					x2="927.73"
					y2="499.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="927.73"
					y1="499.61"
					x2="926.26"
					y2="494.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="926.26"
					y1="494.44"
					x2="925.64"
					y2="489.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="925.64"
					y1="489.28"
					x2="925.64"
					y2="487.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="914.43"
					y1="476.93"
					x2="917.29"
					y2="476.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="917.29"
					y1="476.91"
					x2="920.07"
					y2="476.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="920.07"
					y1="476.44"
					x2="923.07"
					y2="475.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.07"
					y1="475.28"
					x2="927.45"
					y2="472.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="927.45"
					y1="472.7"
					x2="928.9"
					y2="472.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="928.9"
					y1="472.29"
					x2="930.4"
					y2="472.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.4"
					y1="472.2"
					x2="931.86"
					y2="472.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="931.86"
					y1="472.41"
					x2="933.23"
					y2="472.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="936.22"
					y1="479.04"
					x2="935.75"
					y2="477.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.75"
					y1="477.04"
					x2="934.75"
					y2="475.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.75"
					y1="475.86"
					x2="933.35"
					y2="475.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="933.35"
					y1="475.12"
					x2="931.52"
					y2="474.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="931.52"
					y1="474.76"
					x2="929.63"
					y2="474.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="929.63"
					y1="474.68"
					x2="928.69"
					y2="474.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="928.69"
					y1="474.69"
					x2="927.95"
					y2="475.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="927.95"
					y1="475.09"
					x2="927.73"
					y2="475.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="927.73"
					y1="475.55"
					x2="926.26"
					y2="480.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="926.26"
					y1="480.72"
					x2="925.64"
					y2="485.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="925.64"
					y1="485.88"
					x2="925.64"
					y2="487.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.89"
					y1="487.58"
					x2="892.13"
					y2="485.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.13"
					y1="485.54"
					x2="892.65"
					y2="483.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.65"
					y1="483.56"
					x2="893.66"
					y2="481.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="893.66"
					y1="481.47"
					x2="895.32"
					y2="479.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.32"
					y1="479.53"
					x2="897.41"
					y2="478.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="897.41"
					y1="478.06"
					x2="899.78"
					y2="476.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="899.78"
					y1="476.99"
					x2="902.3"
					y2="476.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="902.3"
					y1="476.2"
					x2="906.37"
					y2="475.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.37"
					y1="475.49"
					x2="908.42"
					y2="475.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.42"
					y1="475.46"
					x2="910.47"
					y2="475.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.47"
					y1="475.68"
					x2="913.65"
					y2="476.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="913.65"
					y1="476.61"
					x2="916.72"
					y2="478.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.72"
					y1="478.05"
					x2="919.46"
					y2="479.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="919.46"
					y1="479.76"
					x2="921.66"
					y2="481.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="926.27"
					y1="501.89"
					x2="925.8"
					y2="501.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="925.8"
					y1="501.57"
					x2="925.11"
					y2="500.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="925.11"
					y1="500.62"
					x2="924.94"
					y2="499.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="924.94"
					y1="499.81"
					x2="924.29"
					y2="489.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="924.29"
					y1="489.3"
					x2="924.29"
					y2="487.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="926.27"
					y1="473.27"
					x2="925.8"
					y2="473.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="925.8"
					y1="473.6"
					x2="925.11"
					y2="474.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="925.11"
					y1="474.53"
					x2="924.94"
					y2="475.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="924.94"
					y1="475.35"
					x2="924.29"
					y2="485.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="924.29"
					y1="485.86"
					x2="924.29"
					y2="487.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.97"
					y1="474.26"
					x2="935.35"
					y2="474.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.35"
					y1="474.73"
					x2="936.16"
					y2="476.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="936.16"
					y1="476.19"
					x2="936.61"
					y2="477.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="936.61"
					y1="477.58"
					x2="936.84"
					y2="479.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="936.18"
					y1="504.02"
					x2="936.84"
					y2="504.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="936.84 467.85 936.84 471.14 936.18 471.14 936.18 467.85 936.84 467.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="936.84"
					y1="467.85"
					x2="936.84"
					y2="471.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="936.84"
					y1="471.14"
					x2="936.18"
					y2="471.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="936.18"
					y1="471.14"
					x2="936.18"
					y2="467.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="936.18"
					y1="467.85"
					x2="936.84"
					y2="467.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="936.18 506 930.83 506 930.83 505.34 936.18 505.34 936.18 506"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="936.18"
					y1="506"
					x2="930.83"
					y2="506"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.83"
					y1="506"
					x2="930.83"
					y2="505.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.83"
					y1="505.34"
					x2="936.18"
					y2="505.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="936.18"
					y1="505.34"
					x2="936.18"
					y2="506"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="936.18 469.16 936.18 469.82 930.83 469.82 930.83 469.16 936.18 469.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="936.18"
					y1="469.16"
					x2="936.18"
					y2="469.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="936.18"
					y1="469.82"
					x2="930.83"
					y2="469.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.83"
					y1="469.82"
					x2="930.83"
					y2="469.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.83"
					y1="469.16"
					x2="936.18"
					y2="469.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="932.48 505.34 931.16 505.34 931.16 469.82 932.48 469.82 932.48 505.34"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="932.48"
					y1="505.34"
					x2="931.16"
					y2="505.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="931.16"
					y1="505.34"
					x2="931.16"
					y2="469.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="931.16"
					y1="469.82"
					x2="932.48"
					y2="469.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="932.48"
					y1="469.82"
					x2="932.48"
					y2="505.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="543.38 672.1 543.38 704.97 585.44 704.97 585.44 672.1 543.38 672.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="543.38"
					y1="672.1"
					x2="585.44"
					y2="672.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.38"
					y1="704.97"
					x2="585.44"
					y2="704.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="585.44"
					y1="672.1"
					x2="585.44"
					y2="704.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.38"
					y1="672.1"
					x2="543.38"
					y2="704.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.38"
					y1="703.67"
					x2="585.44"
					y2="703.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.97"
					y1="679.9"
					x2="580.85"
					y2="679.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.85"
					y1="679.9"
					x2="580.85"
					y2="699.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.85"
					y1="699.63"
					x2="547.97"
					y2="699.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.97"
					y1="699.63"
					x2="547.97"
					y2="679.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.67"
					y1="678.61"
					x2="582.15"
					y2="678.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.15"
					y1="678.61"
					x2="582.15"
					y2="700.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.15"
					y1="700.93"
					x2="546.67"
					y2="700.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.67"
					y1="700.93"
					x2="546.67"
					y2="678.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m566.35,695.18c0-1.07-.87-1.94-1.94-1.94s-1.94.87-1.94,1.94.87,1.94,1.94,1.94,1.94-.87,1.94-1.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="562.79 703.19 563.05 700.48 563.26 699.86 563.69 696.43 563.93 695.98 564.41 695.8 564.89 695.98 565.13 696.43 565.55 699.86 565.77 700.48 566.03 703.19 565.55 704.34 564.41 704.81 563.26 704.34 562.79 703.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="562.79"
					y1="703.19"
					x2="563.05"
					y2="700.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m563.05,700.48c.02-.22.09-.43.21-.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.26"
					y1="699.86"
					x2="563.69"
					y2="696.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m563.69,696.43c.05-.36.36-.63.72-.63s.68.27.72.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="565.13"
					y1="696.43"
					x2="565.55"
					y2="699.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m565.55,699.86c.12.18.19.39.21.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="565.77"
					y1="700.48"
					x2="566.03"
					y2="703.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m566.03,703.19c0,.89-.73,1.62-1.62,1.62s-1.62-.73-1.62-1.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="565.29"
					y1="701.58"
					x2="565.29"
					y2="700.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.53"
					y1="700.62"
					x2="563.53"
					y2="701.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.53"
					y1="701.58"
					x2="565.29"
					y2="701.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m563.53,700.62c0-.49.39-.88.88-.88s.88.39.88.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m563.26,699.86c.25-.39.68-.63,1.15-.63s.9.24,1.15.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="521.71 661.79 518.77 660.48 515.59 660.02 512.41 660.48 509.48 661.79 506.08 665.53 504.21 670.43 503.57 676.55 504.94 682.56 504.49 687.95 502.24 692.88 501.36 694.27 500.32 697.12 500.47 700.16 500.94 701.36 500.94 704.55 502.28 704.55 502.28 703.1 504.5 704.45 507.05 704.97 524.13 704.97 527.43 704.08 529.91 701.73 530.98 698.48 530.98 698.09 530.64 696.03 528.9 692.8 526.67 687.93 526.23 682.6 527.62 676.58 526.97 670.43 525.11 665.53 521.71 661.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="509.51"
					y1="689.79"
					x2="521.68"
					y2="689.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.13"
					y1="704.97"
					x2="515.59"
					y2="704.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.13"
					y1="704.35"
					x2="515.59"
					y2="704.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.05"
					y1="704.97"
					x2="515.59"
					y2="704.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.05"
					y1="704.35"
					x2="515.59"
					y2="704.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.36"
					y1="689.79"
					x2="521.36"
					y2="692.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.36"
					y1="692.06"
					x2="519.48"
					y2="692.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.48"
					y1="692.06"
					x2="519.48"
					y2="689.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.82"
					y1="689.79"
					x2="509.82"
					y2="692.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.82"
					y1="692.06"
					x2="511.7"
					y2="692.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.7"
					y1="692.06"
					x2="511.7"
					y2="689.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.28"
					y1="698.9"
					x2="502.28"
					y2="704.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.94"
					y1="698.9"
					x2="500.94"
					y2="704.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.94"
					y1="704.55"
					x2="502.28"
					y2="704.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.94"
					y1="698.9"
					x2="502.28"
					y2="698.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.59"
					y1="660.02"
					x2="517.63"
					y2="660.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.63"
					y1="660.26"
					x2="519.61"
					y2="660.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.61"
					y1="660.78"
					x2="521.71"
					y2="661.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.71"
					y1="661.79"
					x2="523.64"
					y2="663.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.64"
					y1="663.45"
					x2="525.11"
					y2="665.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.11"
					y1="665.53"
					x2="526.19"
					y2="667.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.19"
					y1="667.91"
					x2="526.97"
					y2="670.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.97"
					y1="670.43"
					x2="527.68"
					y2="674.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.68"
					y1="674.5"
					x2="527.72"
					y2="676.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.72"
					y1="676.55"
					x2="527.49"
					y2="678.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.49"
					y1="678.6"
					x2="526.57"
					y2="681.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.57"
					y1="681.77"
					x2="525.12"
					y2="684.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.12"
					y1="684.85"
					x2="523.42"
					y2="687.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.42"
					y1="687.59"
					x2="521.68"
					y2="689.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.23"
					y1="682.6"
					x2="526.24"
					y2="685.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.24"
					y1="685.45"
					x2="526.72"
					y2="688.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.72"
					y1="688.22"
					x2="527.89"
					y2="691.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.89"
					y1="691.19"
					x2="530.48"
					y2="695.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.48"
					y1="695.58"
					x2="530.96"
					y2="697.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.96"
					y1="697.75"
					x2="530.78"
					y2="699.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.78"
					y1="699.92"
					x2="529.93"
					y2="701.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.93"
					y1="701.89"
					x2="528.44"
					y2="703.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.44"
					y1="703.48"
					x2="526.98"
					y2="704.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.98"
					y1="704.29"
					x2="525.59"
					y2="704.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.59"
					y1="704.74"
					x2="524.13"
					y2="704.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.13"
					y1="704.35"
					x2="526.13"
					y2="703.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.13"
					y1="703.87"
					x2="527.32"
					y2="702.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.32"
					y1="702.87"
					x2="528.06"
					y2="701.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.06"
					y1="701.48"
					x2="528.41"
					y2="699.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.41"
					y1="699.65"
					x2="528.49"
					y2="697.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.49"
					y1="697.76"
					x2="528.48"
					y2="696.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.48"
					y1="696.82"
					x2="528.09"
					y2="696.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.09"
					y1="696.08"
					x2="527.62"
					y2="695.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.62"
					y1="695.86"
					x2="522.46"
					y2="694.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.46"
					y1="694.39"
					x2="517.29"
					y2="693.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.29"
					y1="693.76"
					x2="515.59"
					y2="693.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.94"
					y1="682.56"
					x2="504.92"
					y2="685.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.92"
					y1="685.42"
					x2="504.46"
					y2="688.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.46"
					y1="688.2"
					x2="503.29"
					y2="691.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.29"
					y1="691.19"
					x2="500.71"
					y2="695.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.71"
					y1="695.58"
					x2="500.31"
					y2="697.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.31"
					y1="697.03"
					x2="500.21"
					y2="698.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.21"
					y1="698.52"
					x2="500.42"
					y2="699.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.42"
					y1="699.99"
					x2="500.94"
					y2="701.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.05"
					y1="704.35"
					x2="505.06"
					y2="703.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.06"
					y1="703.87"
					x2="503.87"
					y2="702.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.87"
					y1="702.87"
					x2="503.13"
					y2="701.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.13"
					y1="701.48"
					x2="502.78"
					y2="699.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.78"
					y1="699.65"
					x2="502.69"
					y2="697.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.69"
					y1="697.76"
					x2="502.7"
					y2="696.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.7"
					y1="696.82"
					x2="503.1"
					y2="696.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.1"
					y1="696.08"
					x2="503.56"
					y2="695.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.56"
					y1="695.86"
					x2="508.73"
					y2="694.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.73"
					y1="694.39"
					x2="513.9"
					y2="693.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.9"
					y1="693.76"
					x2="515.59"
					y2="693.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.59"
					y1="660.02"
					x2="513.55"
					y2="660.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.55"
					y1="660.26"
					x2="511.58"
					y2="660.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.58"
					y1="660.78"
					x2="509.48"
					y2="661.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.48"
					y1="661.79"
					x2="507.54"
					y2="663.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.54"
					y1="663.45"
					x2="506.08"
					y2="665.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.08"
					y1="665.53"
					x2="505"
					y2="667.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505"
					y1="667.91"
					x2="504.21"
					y2="670.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.21"
					y1="670.43"
					x2="503.5"
					y2="674.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.5"
					y1="674.5"
					x2="503.47"
					y2="676.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.47"
					y1="676.55"
					x2="503.7"
					y2="678.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.7"
					y1="678.6"
					x2="504.62"
					y2="681.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.62"
					y1="681.77"
					x2="506.06"
					y2="684.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.06"
					y1="684.85"
					x2="507.77"
					y2="687.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.77"
					y1="687.59"
					x2="509.51"
					y2="689.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.9"
					y1="694.39"
					x2="529.58"
					y2="693.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.58"
					y1="693.93"
					x2="528.64"
					y2="693.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.64"
					y1="693.24"
					x2="527.82"
					y2="693.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.82"
					y1="693.07"
					x2="517.32"
					y2="692.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.32"
					y1="692.42"
					x2="515.59"
					y2="692.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.28"
					y1="694.39"
					x2="501.61"
					y2="693.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.61"
					y1="693.93"
					x2="502.55"
					y2="693.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.55"
					y1="693.24"
					x2="503.36"
					y2="693.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.36"
					y1="693.07"
					x2="513.87"
					y2="692.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.87"
					y1="692.42"
					x2="515.59"
					y2="692.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.28"
					y1="703.1"
					x2="502.74"
					y2="703.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.74"
					y1="703.48"
					x2="504.2"
					y2="704.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.2"
					y1="704.29"
					x2="505.6"
					y2="704.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.6"
					y1="704.74"
					x2="507.05"
					y2="704.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="535.32 704.97 535.32 704.31 532.04 704.31 532.04 704.97 535.32 704.97"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="532.04"
					y1="704.97"
					x2="535.32"
					y2="704.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.04"
					y1="704.31"
					x2="532.04"
					y2="704.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.32"
					y1="704.31"
					x2="532.04"
					y2="704.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.32"
					y1="704.97"
					x2="535.32"
					y2="704.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="495.86 704.97 499.15 704.97 499.15 704.31 495.86 704.31 495.86 704.97"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="495.86"
					y1="704.31"
					x2="495.86"
					y2="704.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.15"
					y1="704.31"
					x2="495.86"
					y2="704.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.15"
					y1="704.97"
					x2="499.15"
					y2="704.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.86"
					y1="704.97"
					x2="499.15"
					y2="704.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="534.01 704.31 534.01 698.96 533.35 698.96 533.35 704.31 534.01 704.31"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="533.35"
					y1="704.31"
					x2="534.01"
					y2="704.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.35"
					y1="698.96"
					x2="533.35"
					y2="704.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.01"
					y1="698.96"
					x2="533.35"
					y2="698.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.01"
					y1="704.31"
					x2="534.01"
					y2="698.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="497.18 704.31 497.84 704.31 497.84 698.96 497.18 698.96 497.18 704.31"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="497.18"
					y1="698.96"
					x2="497.18"
					y2="704.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.84"
					y1="698.96"
					x2="497.18"
					y2="698.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.84"
					y1="704.31"
					x2="497.84"
					y2="698.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.18"
					y1="704.31"
					x2="497.84"
					y2="704.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="533.35 700.6 533.35 699.29 497.84 699.29 497.84 700.6 533.35 700.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="497.84"
					y1="700.6"
					x2="533.35"
					y2="700.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.84"
					y1="699.29"
					x2="497.84"
					y2="700.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.35"
					y1="699.29"
					x2="497.84"
					y2="699.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.35"
					y1="700.6"
					x2="533.35"
					y2="699.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="694.27 514.72 638.8 514.72 638.8 576.31 694.27 576.31 694.27 514.72"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="694.27"
					y1="576.31"
					x2="694.27"
					y2="514.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.8"
					y1="576.31"
					x2="694.27"
					y2="576.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.8"
					y1="514.72"
					x2="638.8"
					y2="576.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="514.72"
					x2="638.8"
					y2="514.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="518.83"
					x2="638.8"
					y2="518.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="519.53 522.76 519.53 560.28 482.66 560.28 482.66 522.76 519.53 522.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="519.53"
					y1="522.76"
					x2="519.53"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.53"
					y1="526.92"
					x2="519.53"
					y2="530.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.53"
					y1="533.23"
					x2="519.53"
					y2="537.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.53"
					y1="539.55"
					x2="519.53"
					y2="543.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.53"
					y1="545.86"
					x2="519.53"
					y2="549.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.53"
					y1="552.17"
					x2="519.53"
					y2="556.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.53"
					y1="558.49"
					x2="519.53"
					y2="560.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.53"
					y1="560.28"
					x2="518.06"
					y2="560.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.69"
					y1="560.28"
					x2="511.75"
					y2="560.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.38"
					y1="560.28"
					x2="505.43"
					y2="560.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.07"
					y1="560.28"
					x2="499.12"
					y2="560.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.75"
					y1="560.28"
					x2="492.8"
					y2="560.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.44"
					y1="560.28"
					x2="486.49"
					y2="560.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.12"
					y1="560.28"
					x2="482.66"
					y2="560.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.66"
					y1="560.28"
					x2="482.66"
					y2="558.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.66"
					y1="556.12"
					x2="482.66"
					y2="552.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.66"
					y1="549.8"
					x2="482.66"
					y2="545.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.66"
					y1="543.49"
					x2="482.66"
					y2="539.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.66"
					y1="537.18"
					x2="482.66"
					y2="533.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.66"
					y1="530.86"
					x2="482.66"
					y2="526.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.66"
					y1="524.55"
					x2="482.66"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.66"
					y1="522.76"
					x2="484.12"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.49"
					y1="522.76"
					x2="490.44"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.8"
					y1="522.76"
					x2="496.75"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.12"
					y1="522.76"
					x2="503.07"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.43"
					y1="522.76"
					x2="509.38"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.75"
					y1="522.76"
					x2="515.69"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="518.06"
					y1="522.76"
					x2="519.53"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="482.79 520.82 482.79 519.68 519.39 519.68 519.39 520.82 513.65 520.82 513.65 519.89 488.54 519.89 488.54 520.82 482.79 520.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="482.79"
					y1="520.82"
					x2="482.79"
					y2="519.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="482.79"
					y1="519.68"
					x2="519.39"
					y2="519.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="519.39"
					y1="519.68"
					x2="519.39"
					y2="520.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="519.39"
					y1="520.82"
					x2="513.65"
					y2="520.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="513.65"
					y1="520.82"
					x2="513.65"
					y2="519.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="513.65"
					y1="519.89"
					x2="488.54"
					y2="519.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="488.54"
					y1="519.89"
					x2="488.54"
					y2="520.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="488.54"
					y1="520.82"
					x2="482.79"
					y2="520.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<polyline
					points="481.36 520.82 520.82 520.82 520.82 522.76 481.36 522.76 481.36 520.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="481.36"
					y1="520.82"
					x2="520.82"
					y2="520.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="520.82"
					y1="520.82"
					x2="520.82"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="520.82"
					y1="522.76"
					x2="481.36"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="481.36"
					y1="522.76"
					x2="481.36"
					y2="520.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="519.39"
					y1="520.82"
					x2="519.39"
					y2="519.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.39"
					y1="519.68"
					x2="482.79"
					y2="519.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.79"
					y1="519.68"
					x2="482.79"
					y2="520.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.82"
					y1="520.82"
					x2="481.36"
					y2="520.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.54"
					y1="520.82"
					x2="488.54"
					y2="519.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.54"
					y1="519.89"
					x2="513.65"
					y2="519.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.65"
					y1="519.89"
					x2="513.65"
					y2="520.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.82"
					y1="522.76"
					x2="520.82"
					y2="520.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.36"
					y1="520.82"
					x2="481.36"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.36"
					y1="522.76"
					x2="520.82"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="571.36 519.47 571.36 562.22 620.69 562.22 620.69 519.47 571.36 519.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="571.36"
					y1="519.47"
					x2="620.69"
					y2="519.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="571.36"
					y1="562.22"
					x2="620.69"
					y2="562.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="571.36"
					y1="560.93"
					x2="620.69"
					y2="560.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="571.36"
					y1="519.47"
					x2="571.36"
					y2="562.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.69"
					y1="519.47"
					x2="620.69"
					y2="562.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.6"
					y1="521.41"
					x2="617.45"
					y2="521.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.45"
					y1="521.41"
					x2="618.75"
					y2="522.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.75"
					y1="522.71"
					x2="618.75"
					y2="558.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.75"
					y1="558.98"
					x2="617.45"
					y2="560.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.45"
					y1="560.28"
					x2="574.6"
					y2="560.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.6"
					y1="560.28"
					x2="573.3"
					y2="558.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.3"
					y1="558.98"
					x2="573.3"
					y2="522.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.3"
					y1="522.71"
					x2="574.6"
					y2="521.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m590.17,530.16c0-3.58-2.9-6.48-6.47-6.48s-6.47,2.9-6.47,6.48,2.9,6.47,6.47,6.47,6.47-2.9,6.47-6.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m588.55,551.53c0-2.68-2.17-4.86-4.86-4.86s-4.86,2.17-4.86,4.86,2.17,4.85,4.86,4.85,4.86-2.17,4.86-4.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m613.21,530.16c0-2.68-2.17-4.86-4.85-4.86s-4.86,2.17-4.86,4.86,2.17,4.85,4.86,4.85,4.85-2.17,4.85-4.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m614.83,551.53c0-3.58-2.9-6.48-6.47-6.48s-6.48,2.9-6.48,6.48,2.9,6.47,6.48,6.47,6.47-2.9,6.47-6.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="526.2 527.48 567.16 527.48 568.07 527.86 568.45 528.78 568.45 556.2 568.07 557.12 567.16 557.49 526.2 557.49 525.29 557.12 524.91 556.2 524.91 528.78 525.29 527.86 526.2 527.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="526.2"
					y1="527.48"
					x2="567.16"
					y2="527.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m567.16,527.48c.72,0,1.29.58,1.29,1.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.45"
					y1="528.78"
					x2="568.45"
					y2="556.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m568.45,556.2c0,.72-.58,1.29-1.29,1.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="567.16"
					y1="557.49"
					x2="526.2"
					y2="557.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m526.2,557.49c-.72,0-1.29-.58-1.29-1.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.91"
					y1="556.2"
					x2="524.91"
					y2="528.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m524.91,528.78c0-.72.58-1.29,1.29-1.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.44"
					y1="530.72"
					x2="563.92"
					y2="530.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="565.21"
					y1="532.02"
					x2="565.21"
					y2="549.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.92"
					y1="551.02"
					x2="529.44"
					y2="551.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.14"
					y1="549.73"
					x2="528.14"
					y2="532.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.44"
					y1="530.72"
					x2="529.44"
					y2="530.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m563.92,530.72c.72,0,1.29.58,1.29,1.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m565.21,549.73c0,.71-.58,1.29-1.29,1.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m529.44,551.02c-.72,0-1.29-.58-1.29-1.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m528.14,532.02c0-.72.58-1.29,1.29-1.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m548.62,544.55c0-1.07-.87-1.94-1.94-1.94s-1.94.87-1.94,1.94.87,1.94,1.94,1.94,1.94-.87,1.94-1.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="546.1 542.74 546.27 542.33 546.68 542.16 547.09 542.33 547.26 542.74 547.26 555.55 547.09 555.96 546.68 556.13 546.27 555.96 546.1 555.55 546.1 542.74"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m546.1,542.74c0-.32.26-.58.58-.58s.58.26.58.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.26"
					y1="542.74"
					x2="547.26"
					y2="555.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m547.26,555.55c0,.32-.26.58-.58.58s-.58-.26-.58-.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.1"
					y1="555.55"
					x2="546.1"
					y2="542.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="545.39 552.25 546.1 552.25 546.1 555.55 546.27 555.96 546.68 556.13 547.09 555.96 547.26 555.55 547.26 552.25 547.97 552.25 547.97 556.46 545.39 556.46 545.39 552.25"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="545.39"
					y1="552.25"
					x2="546.1"
					y2="552.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.1"
					y1="552.25"
					x2="546.1"
					y2="555.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m547.26,555.55c0,.32-.26.58-.58.58s-.58-.26-.58-.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.26"
					y1="555.55"
					x2="547.26"
					y2="552.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.26"
					y1="552.25"
					x2="547.97"
					y2="552.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.97"
					y1="552.25"
					x2="547.97"
					y2="556.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.97"
					y1="556.46"
					x2="545.39"
					y2="556.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.39"
					y1="556.46"
					x2="545.39"
					y2="552.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="545.41 549.92 546.1 549.92 546.1 552.18 545.41 552.18 545.41 549.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="545.41"
					y1="549.92"
					x2="546.1"
					y2="549.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.1"
					y1="549.92"
					x2="546.1"
					y2="552.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.1"
					y1="552.18"
					x2="545.41"
					y2="552.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.41"
					y1="552.18"
					x2="545.41"
					y2="549.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="547.95 549.92 547.95 552.18 547.26 552.18 547.26 549.92 547.95 549.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="547.95"
					y1="549.92"
					x2="547.95"
					y2="552.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.95"
					y1="552.18"
					x2="547.26"
					y2="552.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.26"
					y1="552.18"
					x2="547.26"
					y2="549.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.26"
					y1="549.92"
					x2="547.95"
					y2="549.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.69"
					y1="648.06"
					x2="688.2"
					y2="648.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.2"
					y1="648.06"
					x2="688.2"
					y2="616.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.69"
					y1="654.63"
					x2="676.69"
					y2="610.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.09"
					y1="610.24"
					x2="647.09"
					y2="654.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.09"
					y1="654.63"
					x2="691.49"
					y2="654.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.49"
					y1="610.24"
					x2="647.09"
					y2="610.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.67"
					y1="654.63"
					x2="690.67"
					y2="610.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.69"
					y1="616.81"
					x2="688.2"
					y2="616.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.49"
					y1="654.63"
					x2="691.49"
					y2="610.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.44"
					y1="514.72"
					x2="640.44"
					y2="511.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.44"
					y1="511.47"
					x2="642.09"
					y2="511.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.09"
					y1="511.47"
					x2="642.09"
					y2="514.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.32"
					y1="522.76"
					x2="693"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.63"
					y1="522.76"
					x2="686.69"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.32"
					y1="522.76"
					x2="680.37"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.01"
					y1="522.76"
					x2="674.06"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.69"
					y1="522.76"
					x2="667.75"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.38"
					y1="522.76"
					x2="661.43"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.06"
					y1="522.76"
					x2="655.12"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.75"
					y1="522.76"
					x2="648.81"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.44"
					y1="522.76"
					x2="642.49"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.12"
					y1="522.76"
					x2="638.8"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.04"
					y1="542.49"
					x2="432.71"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.08"
					y1="542.49"
					x2="439.02"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.39"
					y1="542.49"
					x2="445.34"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.71"
					y1="542.49"
					x2="451.65"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.02"
					y1="542.49"
					x2="457.97"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.33"
					y1="542.49"
					x2="464.28"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="466.65"
					y1="542.49"
					x2="470.59"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.96"
					y1="542.49"
					x2="476.91"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.28"
					y1="542.49"
					x2="483.22"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.59"
					y1="542.49"
					x2="489.54"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.9"
					y1="542.49"
					x2="495.85"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.22"
					y1="542.49"
					x2="502.17"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.53"
					y1="542.49"
					x2="508.48"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.85"
					y1="542.49"
					x2="514.79"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.16"
					y1="542.49"
					x2="521.11"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.48"
					y1="542.49"
					x2="527.42"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.79"
					y1="542.49"
					x2="533.74"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.1"
					y1="542.49"
					x2="540.05"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.42"
					y1="542.49"
					x2="546.36"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.73"
					y1="542.49"
					x2="552.68"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.05"
					y1="542.49"
					x2="558.99"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.36"
					y1="542.49"
					x2="565.3"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="567.67"
					y1="542.49"
					x2="571.62"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.99"
					y1="542.49"
					x2="577.93"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.3"
					y1="542.49"
					x2="584.25"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.61"
					y1="542.49"
					x2="590.56"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.93"
					y1="542.49"
					x2="596.87"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.24"
					y1="542.49"
					x2="603.19"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.56"
					y1="542.49"
					x2="609.5"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.87"
					y1="542.49"
					x2="615.82"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.18"
					y1="542.49"
					x2="622.13"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.5"
					y1="542.49"
					x2="628.45"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.81"
					y1="542.49"
					x2="634.76"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="637.13"
					y1="542.49"
					x2="638.8"
					y2="542.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.04"
					y1="522.76"
					x2="571.36"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.69"
					y1="522.76"
					x2="638.8"
					y2="522.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.71"
					y1="754.99"
					x2="224.71"
					y2="625.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.55"
					y1="625.27"
					x2="211.55"
					y2="754.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.79"
					y1="401.81"
					x2="353.79"
					y2="221.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.64"
					y1="218.03"
					x2="340.64"
					y2="401.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.64"
					y1="401.81"
					x2="353.79"
					y2="401.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.2"
					y1="176.75"
					x2="561.92"
					y2="176.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.2"
					y1="163.6"
					x2="561.92"
					y2="163.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.43"
					y1="176.75"
					x2="779.15"
					y2="176.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.15"
					y1="163.6"
					x2="649.43"
					y2="163.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.03"
					y1="648.06"
					x2="652.03"
					y2="616.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.03"
					y1="616.81"
					x2="673.4"
					y2="616.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.4"
					y1="616.81"
					x2="673.4"
					y2="648.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.4"
					y1="648.06"
					x2="652.03"
					y2="648.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="432.19 163.6 432.19 176.74 396.15 176.74 396.15 234.13 370.56 234.13 370.56 176.74 353.8 176.74 353.8 218.03 340.64 218.03 340.64 163.6 432.19 163.6"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.09"
				/>
				<polygon
					points="649.43 163.6 649.43 176.74 645.23 176.74 645.23 239.18 597 239.18 597 403.47 605.9 403.47 605.9 411.69 588.78 411.69 588.78 176.74 561.91 176.74 561.91 163.6 649.43 163.6"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.09"
				/>
				<polygon
					points="950 443.87 950 624.34 801.59 624.34 801.59 810.28 782.94 810.28 782.94 797.12 788.43 797.12 788.43 611.19 817.3 611.19 817.3 515.72 825.52 515.72 825.52 611.19 921.99 611.19 921.99 557.42 936.84 557.42 936.84 457.01 825.52 457.01 825.52 463.1 817.3 463.1 817.3 457.01 692.81 457.01 692.81 411.69 658.51 411.69 658.51 403.47 715.83 403.47 715.83 411.69 701.02 411.69 701.02 448.8 828.24 448.8 828.24 411.69 813.44 411.69 813.44 403.47 828.24 403.47 828.24 209.3 811.31 209.3 811.31 176.74 779.15 176.74 779.15 163.6 841.4 163.6 841.4 443.87 950 443.87"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.09"
				/>
				<polygon
					points="720.45 797.12 720.45 810.28 631.81 810.28 631.81 718.13 487.41 718.13 487.41 836.4 211.55 836.4 211.55 754.98 224.71 754.98 224.71 823.26 425.59 823.26 425.59 786.95 433.81 786.95 433.81 801.26 474.25 801.26 474.25 676.86 433.81 676.86 433.81 691.14 425.59 691.14 425.59 668.63 474.25 668.63 474.25 646.8 482.48 646.8 482.48 704.97 585.44 704.97 585.44 685.43 636.74 685.43 636.74 584.53 482.48 584.53 482.48 594.18 474.25 594.18 474.25 584.53 422.81 584.53 422.81 530.98 414.61 530.98 414.61 522.76 431.04 522.76 431.04 562.22 638.79 562.22 638.79 576.3 694.28 576.3 694.28 607.77 686.05 607.77 686.05 605.55 644.96 605.55 644.96 659.33 686.05 659.33 686.05 657.09 694.28 657.09 694.28 679.31 686.05 679.31 686.05 667.54 644.96 667.54 644.96 797.12 686.05 797.12 686.05 785.36 694.28 785.36 694.28 797.12 720.45 797.12"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.09"
				/>
				<polygon
					points="362 522.76 362 530.98 353.8 530.98 353.8 573.12 311.65 573.12 311.65 530.98 277.79 530.98 277.79 570 224.71 570 224.71 625.27 211.55 625.27 211.55 517.83 340.64 517.83 340.64 466.34 353.8 466.34 353.8 522.76 362 522.76"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.09"
				/>
			</g>
			<g id="text">
				<path d="m664.13,550.08h-1.07l-1.29-2.15c-.12-.2-.23-.37-.34-.51-.11-.14-.23-.26-.34-.35-.11-.09-.24-.15-.38-.19-.13-.04-.28-.06-.45-.06h-.74v3.27h-.9v-7.68h2.29c.34,0,.64.04.93.13.29.08.53.21.74.38.21.17.38.39.49.64.12.25.18.55.18.89,0,.27-.04.51-.12.74-.08.22-.19.42-.34.59-.15.18-.33.33-.54.45-.21.12-.44.22-.7.28v.02c.13.06.24.12.33.2.1.07.19.16.27.26.09.1.17.21.25.34.09.12.18.27.28.44l1.44,2.31Zm-4.61-6.87v2.79h1.22c.23,0,.43-.03.62-.1.19-.07.36-.16.5-.29.14-.13.25-.28.33-.47.08-.19.12-.39.12-.62,0-.41-.13-.73-.4-.96-.26-.23-.65-.35-1.15-.35h-1.23Zm9.85,4.35h-3.87c.01.61.18,1.08.49,1.41.31.33.75.5,1.3.5.62,0,1.19-.2,1.7-.61v.83c-.48.35-1.12.53-1.91.53s-1.38-.25-1.83-.74c-.44-.5-.66-1.2-.66-2.11,0-.85.24-1.55.72-2.08.49-.54,1.09-.81,1.81-.81s1.27.23,1.67.7c.39.46.59,1.11.59,1.93v.46Zm-.9-.74c0-.51-.13-.9-.37-1.18-.24-.28-.57-.42-1-.42s-.77.15-1.06.44c-.29.3-.47.68-.54,1.16h2.96Zm4.84-4.08c-.17-.1-.37-.14-.58-.14-.61,0-.92.39-.92,1.16v.85h1.29v.75h-1.29v4.74h-.87v-4.74h-.94v-.75h.94v-.89c0-.58.17-1.03.5-1.36.33-.34.75-.5,1.24-.5.27,0,.48.03.64.1v.79Z" />
				<path d="m674.24,550.2c-.16,0-.31-.06-.42-.18-.11-.12-.17-.26-.17-.42s.06-.31.17-.42c.12-.12.26-.18.42-.18s.31.06.43.18c.12.12.18.26.18.42s-.06.31-.18.42c-.12.12-.26.18-.43.18Z" />
				<path d="m493.04,554.8v-7.63h2.63c.59,0,1.05.04,1.36.11.44.1.81.28,1.12.55.4.34.7.78.9,1.31.2.53.3,1.13.3,1.81,0,.58-.07,1.09-.2,1.54s-.31.82-.52,1.11c-.21.29-.44.52-.7.69-.25.17-.55.29-.91.38-.35.09-.76.13-1.22.13h-2.75Zm1.01-.9h1.63c.5,0,.9-.05,1.18-.14.29-.09.52-.23.69-.4.24-.24.42-.56.56-.96.14-.41.2-.9.2-1.47,0-.8-.13-1.41-.4-1.84-.26-.43-.58-.72-.95-.86-.27-.1-.71-.16-1.31-.16h-1.6v5.83Zm8.02.9l-2.02-7.63h1.04l1.16,5c.12.52.23,1.04.32,1.56.19-.82.31-1.28.34-1.41l1.45-5.15h1.22l1.09,3.86c.27.96.47,1.86.59,2.7.1-.48.22-1.04.38-1.66l1.2-4.9h1.01l-2.09,7.63h-.97l-1.61-5.81c-.14-.49-.22-.78-.24-.89-.08.35-.15.65-.22.89l-1.62,5.81h-1.03Z" />
				<path d="m404.52,348.59h-6.18v-11.92h1.4v10.65h4.79v1.26Zm2.34-10.67c-.24,0-.45-.08-.62-.25-.17-.17-.26-.38-.26-.63s.09-.47.26-.63c.17-.17.38-.26.62-.26s.46.09.63.26c.18.17.27.38.27.63s-.09.45-.27.62c-.17.17-.38.26-.63.26Zm.66,10.67h-1.36v-8.51h1.36v8.51Zm9.44-8.51l-3.39,8.51h-1.34l-3.22-8.51h1.5l2.16,6.18c.16.45.26.85.3,1.19h.03c.06-.43.14-.81.27-1.15l2.26-6.22h1.44Zm2.16-2.16c-.24,0-.45-.08-.62-.25s-.26-.38-.26-.63.09-.47.26-.63c.17-.17.38-.26.62-.26s.46.09.63.26c.18.17.27.38.27.63s-.09.45-.27.62c-.17.17-.38.26-.63.26Zm.66,10.67h-1.36v-8.51h1.36v8.51Zm9.81,0h-1.36v-4.85c0-1.81-.66-2.71-1.98-2.71-.68,0-1.25.26-1.7.77-.44.51-.66,1.16-.66,1.94v4.85h-1.36v-8.51h1.36v1.41h.03c.64-1.07,1.57-1.61,2.79-1.61.93,0,1.64.3,2.14.91.49.6.74,1.47.74,2.6v5.2Zm9.83-.68c0,3.12-1.5,4.69-4.49,4.69-1.05,0-1.97-.2-2.76-.6v-1.36c.96.53,1.87.8,2.74.8,2.09,0,3.14-1.11,3.14-3.34v-.93h-.03c-.65,1.09-1.62,1.63-2.92,1.63-1.06,0-1.91-.38-2.56-1.13-.64-.76-.96-1.78-.96-3.05,0-1.45.35-2.6,1.04-3.45.7-.85,1.65-1.28,2.86-1.28s2,.46,2.55,1.38h.03v-1.18h1.36v7.83Zm-1.36-3.17v-1.25c0-.68-.23-1.25-.69-1.74-.45-.48-1.02-.72-1.7-.72-.84,0-1.5.31-1.98.92-.48.61-.71,1.47-.71,2.57,0,.95.23,1.71.68,2.28.46.57,1.07.85,1.82.85s1.38-.27,1.86-.81c.48-.54.72-1.24.72-2.09Z" />
				<polygon points="447.57 336.68 441.85 350.57 440.58 350.57 446.28 336.68 447.57 336.68" />
				<path d="m448.96,348.59v-11.92h3.29c4.2,0,6.3,1.94,6.3,5.81,0,1.84-.58,3.32-1.75,4.44-1.16,1.11-2.72,1.67-4.68,1.67h-3.16Zm1.4-10.65v9.39h1.78c1.56,0,2.78-.42,3.65-1.25.87-.84,1.3-2.02,1.3-3.56,0-3.05-1.62-4.58-4.87-4.58h-1.86Zm11-.02c-.24,0-.45-.08-.62-.25-.17-.17-.26-.38-.26-.63s.09-.47.26-.63c.17-.17.38-.26.62-.26s.46.09.63.26c.18.17.27.38.27.63s-.09.45-.27.62c-.17.17-.38.26-.63.26Zm.66,10.67h-1.36v-8.51h1.36v8.51Zm9.77,0h-1.36v-4.85c0-1.81-.66-2.71-1.98-2.71-.68,0-1.25.26-1.7.77-.44.51-.66,1.15-.66,1.94v4.85h-1.36v-8.51h1.36v1.41h.03c.64-1.07,1.57-1.61,2.79-1.61.93,0,1.64.3,2.14.91.49.6.74,1.47.74,2.6v5.2Zm3.22-10.67c-.24,0-.45-.08-.62-.25-.17-.17-.26-.38-.26-.63s.09-.47.26-.63c.17-.17.38-.26.62-.26s.46.09.63.26c.18.17.27.38.27.63s-.09.45-.27.62c-.17.17-.38.26-.63.26Zm.66,10.67h-1.36v-8.51h1.36v8.51Zm9.77,0h-1.36v-4.85c0-1.81-.66-2.71-1.98-2.71-.68,0-1.25.26-1.7.77-.44.51-.66,1.15-.66,1.94v4.85h-1.36v-8.51h1.36v1.41h.03c.64-1.07,1.57-1.61,2.79-1.61.93,0,1.64.3,2.14.91.49.6.74,1.47.74,2.6v5.2Zm9.78-.68c0,3.12-1.5,4.69-4.49,4.69-1.05,0-1.97-.2-2.76-.6v-1.36c.96.53,1.87.8,2.74.8,2.09,0,3.14-1.11,3.14-3.34v-.93h-.03c-.65,1.09-1.62,1.63-2.92,1.63-1.06,0-1.91-.38-2.56-1.13-.64-.76-.96-1.78-.96-3.05,0-1.45.35-2.6,1.04-3.45.7-.85,1.65-1.28,2.86-1.28s2,.46,2.55,1.38h.03v-1.18h1.36v7.83Zm-1.36-3.17v-1.25c0-.68-.23-1.25-.69-1.74-.45-.48-1.02-.72-1.7-.72-.84,0-1.5.31-1.98.92-.48.61-.71,1.47-.71,2.57,0,.95.23,1.71.68,2.28.46.57,1.07.85,1.82.85s1.38-.27,1.86-.81c.48-.54.72-1.24.72-2.09Z" />
				<path d="m511.52,348.59h-1.66l-1.99-3.34c-.18-.31-.36-.57-.53-.79-.17-.22-.35-.4-.53-.54-.18-.14-.37-.24-.58-.3-.2-.07-.44-.1-.7-.1h-1.15v5.07h-1.4v-11.92h3.56c.52,0,1,.07,1.44.2.44.13.83.32,1.15.59.33.27.58.6.76,1,.18.39.27.86.27,1.39,0,.42-.06.8-.19,1.15-.12.34-.3.65-.53.92-.23.27-.5.5-.83.7-.32.19-.68.34-1.09.44v.03c.2.09.37.19.52.31.15.11.29.24.42.4.13.16.26.33.39.53.13.19.28.42.44.68l2.24,3.58Zm-7.15-10.65v4.32h1.89c.35,0,.67-.05.96-.16.3-.11.56-.25.77-.45.22-.2.38-.44.51-.72.12-.29.18-.61.18-.96,0-.64-.21-1.13-.62-1.49-.41-.36-1.01-.54-1.79-.54h-1.91Zm12.11,10.85c-1.26,0-2.26-.4-3.02-1.19-.75-.8-1.12-1.85-1.12-3.17,0-1.43.39-2.55,1.17-3.35.78-.8,1.84-1.2,3.17-1.2s2.26.39,2.97,1.17c.71.78,1.07,1.86,1.07,3.25s-.38,2.45-1.15,3.27c-.76.81-1.79,1.22-3.08,1.22Zm.1-7.76c-.88,0-1.57.3-2.08.9-.51.59-.76,1.41-.76,2.46s.26,1.8.77,2.38c.52.58,1.2.87,2.07.87s1.56-.29,2.03-.86c.48-.57.71-1.38.71-2.43s-.24-1.88-.71-2.46c-.47-.58-1.15-.86-2.03-.86Zm9.82,7.76c-1.26,0-2.26-.4-3.02-1.19-.75-.8-1.12-1.85-1.12-3.17,0-1.43.39-2.55,1.17-3.35.78-.8,1.84-1.2,3.17-1.2s2.26.39,2.97,1.17c.71.78,1.07,1.86,1.07,3.25s-.38,2.45-1.15,3.27c-.76.81-1.79,1.22-3.08,1.22Zm.1-7.76c-.88,0-1.57.3-2.08.9-.51.59-.76,1.41-.76,2.46s.26,1.8.77,2.38c.52.58,1.2.87,2.07.87s1.56-.29,2.03-.86c.48-.57.71-1.38.71-2.43s-.24-1.88-.71-2.46c-.47-.58-1.15-.86-2.03-.86Zm18.35,7.56h-1.36v-4.89c0-.94-.15-1.62-.44-2.04-.29-.42-.78-.63-1.46-.63-.58,0-1.08.27-1.49.8-.4.53-.61,1.17-.61,1.91v4.85h-1.36v-5.05c0-1.67-.65-2.51-1.94-2.51-.6,0-1.09.25-1.48.76-.39.5-.58,1.15-.58,1.95v4.85h-1.36v-8.51h1.36v1.35h.03c.6-1.03,1.48-1.55,2.64-1.55.58,0,1.09.16,1.52.49.43.32.73.75.89,1.27.63-1.17,1.57-1.76,2.83-1.76,1.87,0,2.81,1.16,2.81,3.46v5.24Z" />
				<path d="m438.36,366.26h-.99v-7.49c-.08.08-.19.17-.34.27-.15.1-.31.19-.5.29-.18.1-.38.19-.58.27-.2.08-.4.15-.59.2v-1c.22-.06.45-.14.69-.24.25-.1.49-.22.72-.34.24-.13.46-.26.67-.4.21-.14.39-.28.54-.41h.38v8.87Zm6.69,0h-.99v-7.49c-.08.08-.19.17-.34.27-.15.1-.31.19-.5.29-.18.1-.38.19-.58.27-.2.08-.4.15-.59.2v-1c.22-.06.45-.14.69-.24.25-.1.49-.22.72-.34.24-.13.46-.26.67-.4.21-.14.39-.28.54-.41h.38v8.87Z" />
				<rect x="448.33" y="357.59" width=".88" height="2.7" />
				<path d="m454.53,366.26h-.99v-7.49c-.08.08-.19.17-.34.27-.15.1-.31.19-.5.29-.18.1-.38.19-.58.27-.2.08-.4.15-.59.2v-1c.22-.06.45-.14.69-.24.25-.1.49-.22.72-.34.24-.13.46-.26.67-.4.21-.14.39-.28.54-.41h.38v8.87Zm8.48-4.37c0,.73-.07,1.37-.2,1.93-.13.56-.32,1.03-.57,1.42-.25.38-.55.68-.91.88-.36.2-.77.3-1.23.3-.44,0-.82-.09-1.17-.28-.34-.19-.63-.47-.86-.84-.23-.37-.41-.82-.53-1.35-.12-.54-.18-1.15-.18-1.84,0-.76.06-1.43.19-2.01.13-.58.32-1.07.56-1.46.25-.4.55-.69.91-.89.37-.2.79-.3,1.26-.3,1.82,0,2.73,1.48,2.73,4.45Zm-1.02.1c0-2.47-.59-3.7-1.76-3.7-1.24,0-1.86,1.26-1.86,3.77,0,2.34.61,3.51,1.82,3.51s1.8-1.19,1.8-3.58Z" />
				<path d="m465.39,357.59v2.7h-.88v-2.7h.88Zm2.01,0v2.7h-.88v-2.7h.88Z" />
				<path d="m477.31,360.07l-2.08,3.13,2.04,3.06h-1.16l-1.22-2.01c-.08-.13-.17-.28-.27-.47h-.02s-.11.19-.28.47l-1.24,2.01h-1.14l2.11-3.04-2.02-3.16h1.16l1.2,2.12c.09.16.18.32.26.48h.02l1.55-2.6h1.09Z" />
				<path d="m485.24,366.26h-.99v-7.49c-.08.08-.19.17-.34.27-.15.1-.31.19-.5.29-.18.1-.37.19-.58.27-.2.08-.4.15-.59.2v-1c.22-.06.45-.14.69-.24.25-.1.49-.22.72-.34.24-.13.46-.26.67-.4.21-.14.39-.28.54-.41h.38v8.87Zm8.42-8.1c-.13.23-.29.52-.48.86-.19.34-.38.73-.59,1.16-.21.43-.42.89-.64,1.38-.22.49-.42,1-.61,1.52-.19.52-.36,1.06-.5,1.6-.14.54-.24,1.06-.31,1.58h-1.06c.07-.52.18-1.04.33-1.58.15-.54.32-1.07.51-1.58.19-.52.4-1.02.61-1.5.21-.48.42-.92.62-1.32.2-.4.39-.76.55-1.06.17-.31.3-.55.41-.73h-4.35v-.9h5.52v.57Z" />
				<rect x="495.21" y="357.59" width=".88" height="2.7" />
				<path d="m502.9,363.61c0,.42-.07.81-.22,1.15-.15.34-.35.64-.62.88-.27.25-.59.44-.97.57-.38.13-.8.2-1.26.2-.81,0-1.41-.12-1.8-.36v-1.05c.59.38,1.19.57,1.81.57.31,0,.6-.05.85-.14.25-.09.47-.22.65-.39s.31-.36.41-.6c.1-.23.15-.49.15-.77,0-.56-.19-1.01-.57-1.32-.38-.32-.93-.48-1.65-.48-.12,0-.24,0-.37,0-.13,0-.26.01-.39.02-.13,0-.26.01-.38.02-.12,0-.23.02-.33.03l.3-4.35h4.01v.9h-3.15l-.18,2.55c.13,0,.27-.01.41-.02.15,0,.27-.01.39-.01.46,0,.87.06,1.23.18.36.12.67.29.92.52.25.22.45.5.57.82.13.32.2.69.2,1.09Z" />
				<path d="m505.58,357.59v2.7h-.88v-2.7h.88Zm2.01,0v2.7h-.88v-2.7h.88Z" />
				<path d="m285.23,695.47v-11.92h3.39c1.03,0,1.85.25,2.45.76s.91,1.16.91,1.97c0,.68-.18,1.26-.55,1.76-.37.5-.87.85-1.51,1.06v.03c.8.09,1.45.4,1.93.91.48.51.72,1.17.72,1.99,0,1.02-.37,1.84-1.1,2.48-.73.63-1.65.95-2.77.95h-3.47Zm1.4-10.65v3.85h1.43c.76,0,1.37-.18,1.8-.55.44-.37.66-.89.66-1.56,0-1.16-.76-1.74-2.29-1.74h-1.6Zm0,5.1v4.29h1.89c.82,0,1.45-.19,1.9-.58.45-.39.68-.92.68-1.6,0-1.41-.96-2.11-2.88-2.11h-1.6Zm15,1.64h-6.01c.02.95.28,1.68.76,2.19.49.52,1.16.77,2.01.77.96,0,1.84-.32,2.64-.95v1.28c-.75.54-1.74.81-2.97.81s-2.15-.38-2.83-1.16c-.69-.78-1.03-1.86-1.03-3.27,0-1.32.37-2.4,1.12-3.23.75-.84,1.69-1.25,2.8-1.25s1.97.36,2.58,1.08c.61.72.91,1.72.91,3v.71Zm-1.4-1.16c0-.79-.2-1.4-.57-1.84-.37-.44-.89-.66-1.55-.66s-1.19.23-1.64.69-.73,1.06-.83,1.8h4.6Zm10.71,5.07h-1.36v-1.45h-.03c-.63,1.1-1.61,1.65-2.92,1.65-1.07,0-1.92-.38-2.57-1.14-.64-.76-.96-1.8-.96-3.12,0-1.41.35-2.53,1.06-3.38.71-.85,1.65-1.27,2.83-1.27s2.02.46,2.55,1.38h.03v-5.27h1.36v12.6Zm-1.36-3.85v-1.25c0-.69-.23-1.27-.68-1.74s-1.03-.71-1.73-.71c-.83,0-1.48.3-1.96.91s-.71,1.45-.71,2.53c0,.98.23,1.76.68,2.33.46.57,1.07.85,1.84.85s1.37-.27,1.84-.82c.48-.55.71-1.24.71-2.08Zm8.55-3.28c-.24-.18-.58-.27-1.03-.27-.58,0-1.07.27-1.46.82-.39.55-.58,1.3-.58,2.24v4.34h-1.36v-8.51h1.36v1.75h.03c.19-.6.49-1.06.89-1.4.4-.34.84-.51,1.34-.51.35,0,.63.04.81.12v1.41Zm5.03,7.33c-1.26,0-2.26-.4-3.02-1.19-.75-.8-1.12-1.85-1.12-3.17,0-1.43.39-2.55,1.17-3.35.78-.8,1.84-1.2,3.17-1.2s2.26.39,2.97,1.17c.71.78,1.07,1.86,1.07,3.25s-.38,2.45-1.15,3.27c-.76.81-1.79,1.22-3.08,1.22Zm.1-7.76c-.88,0-1.57.3-2.08.9-.51.59-.76,1.41-.76,2.46s.26,1.8.77,2.38c.52.58,1.2.87,2.07.87s1.56-.29,2.03-.86c.48-.57.71-1.38.71-2.43s-.24-1.88-.71-2.46c-.47-.58-1.15-.86-2.03-.86Zm9.86,7.76c-1.26,0-2.26-.4-3.02-1.19-.75-.8-1.12-1.85-1.12-3.17,0-1.43.39-2.55,1.17-3.35s1.84-1.2,3.17-1.2,2.26.39,2.97,1.17c.71.78,1.07,1.86,1.07,3.25s-.38,2.45-1.15,3.27c-.76.81-1.79,1.22-3.08,1.22Zm.1-7.76c-.88,0-1.57.3-2.08.9-.51.59-.76,1.41-.76,2.46s.26,1.8.77,2.38c.52.58,1.2.87,2.07.87s1.56-.29,2.03-.86c.48-.57.71-1.38.71-2.43s-.24-1.88-.71-2.46c-.47-.58-1.15-.86-2.03-.86Zm18.39,7.56h-1.36v-4.89c0-.94-.15-1.62-.44-2.04-.29-.42-.78-.63-1.46-.63-.58,0-1.08.27-1.49.8-.4.53-.61,1.17-.61,1.91v4.85h-1.36v-5.05c0-1.67-.65-2.51-1.94-2.51-.6,0-1.09.25-1.48.76-.39.5-.58,1.15-.58,1.95v4.85h-1.36v-8.51h1.36v1.35h.03c.6-1.03,1.48-1.55,2.64-1.55.58,0,1.09.16,1.52.49.43.32.73.74.89,1.27.63-1.17,1.57-1.76,2.83-1.76,1.87,0,2.81,1.16,2.81,3.46v5.24Z" />
				<path d="m363.45,695.47h-1.36v-10.29c-.11.11-.26.23-.47.37-.2.13-.43.27-.68.4-.25.13-.52.26-.8.37-.28.12-.55.21-.81.27v-1.38c.3-.08.61-.19.95-.33.34-.14.67-.3.99-.47.33-.18.63-.36.92-.55.29-.19.54-.38.75-.57h.52v12.18Z" />
				<path d="m292.22,713.14h-.99v-7.49c-.08.08-.19.17-.34.27-.15.1-.31.19-.5.29-.18.1-.38.19-.58.27-.2.08-.4.15-.59.2v-1c.22-.06.45-.14.69-.24.25-.1.49-.22.72-.34.24-.13.46-.26.67-.4.21-.14.39-.28.54-.41h.38v8.87Zm8.48-4.37c0,.73-.07,1.37-.2,1.93-.13.56-.32,1.03-.57,1.42-.25.38-.55.68-.91.88-.36.2-.77.3-1.23.3-.44,0-.82-.09-1.17-.28-.34-.19-.63-.47-.86-.84-.23-.37-.41-.82-.53-1.35-.12-.54-.18-1.15-.18-1.84,0-.76.06-1.43.19-2.01.13-.58.32-1.07.56-1.46.25-.4.55-.69.91-.89.37-.2.79-.3,1.26-.3,1.82,0,2.73,1.48,2.73,4.45Zm-1.02.1c0-2.47-.59-3.7-1.76-3.7-1.24,0-1.86,1.26-1.86,3.77,0,2.34.61,3.51,1.82,3.51s1.8-1.19,1.8-3.58Z" />
				<rect x="302.2" y="704.46" width=".88" height="2.7" />
				<path d="m309.78,710.68c0,.39-.07.75-.22,1.07-.15.32-.35.59-.62.82-.27.23-.59.4-.96.53-.38.13-.79.19-1.24.19-.83,0-1.48-.16-1.97-.47v-1.06c.58.46,1.25.69,2.01.69.3,0,.57-.04.82-.11.25-.08.46-.19.63-.33.18-.15.31-.32.41-.53.1-.21.15-.44.15-.7,0-1.13-.81-1.7-2.42-1.7h-.72v-.84h.68c1.43,0,2.14-.53,2.14-1.6,0-.98-.54-1.48-1.63-1.48-.61,0-1.19.21-1.72.62v-.96c.55-.33,1.21-.5,1.97-.5.36,0,.69.05.99.15.29.1.55.24.76.42.21.18.37.4.48.65.12.25.18.53.18.84,0,1.14-.58,1.88-1.73,2.2v.02c.29.03.57.1.82.22.25.11.47.25.65.43.18.18.32.39.42.63.1.24.16.5.16.79Z" />
				<path d="m312.57,704.46v2.7h-.88v-2.7h.88Zm2.01,0v2.7h-.88v-2.7h.88Z" />
				<path d="m324.48,706.94l-2.08,3.13,2.04,3.06h-1.16l-1.22-2.01c-.08-.13-.17-.28-.27-.47h-.02s-.11.19-.28.47l-1.24,2.01h-1.14l2.11-3.04-2.02-3.16h1.16l1.2,2.12c.09.16.18.32.26.48h.02l1.55-2.6h1.09Z" />
				<path d="m332.42,713.14h-.99v-7.49c-.08.08-.19.17-.34.27-.15.1-.31.19-.5.29-.18.1-.38.19-.58.27-.2.08-.4.15-.59.2v-1c.22-.06.45-.14.69-.24.25-.1.49-.22.72-.34.24-.13.46-.26.67-.4.21-.14.39-.28.54-.41h.38v8.87Zm6.98-6.4c0-.27-.04-.5-.13-.7-.08-.2-.19-.36-.34-.49-.14-.13-.31-.23-.5-.3-.19-.06-.4-.1-.63-.1-.19,0-.38.03-.57.08-.19.05-.37.13-.54.22-.17.09-.34.2-.51.33-.16.13-.31.27-.45.43v-1.06c.28-.27.59-.48.93-.62.35-.15.77-.22,1.26-.22.35,0,.68.05.99.16.3.1.56.25.79.45.22.2.4.44.52.73.13.29.19.62.19,1,0,.34-.04.65-.12.93-.08.28-.2.54-.36.79-.16.25-.36.48-.6.71s-.53.46-.85.69c-.41.29-.74.54-1.01.74-.26.21-.47.4-.63.58-.15.18-.26.36-.33.54-.06.18-.09.38-.09.62h4.32v.89h-5.35v-.43c0-.37.04-.7.12-.98.08-.28.21-.55.4-.8.19-.25.43-.51.73-.76.3-.25.67-.54,1.11-.86.31-.23.58-.44.79-.65.21-.21.39-.41.51-.62.13-.21.22-.41.27-.62.06-.21.08-.44.08-.68h0Z" />
				<rect x="342.39" y="704.46" width=".88" height="2.7" />
				<path d="m348.59,713.14h-.99v-7.49c-.08.08-.19.17-.34.27-.15.1-.31.19-.5.29-.18.1-.38.19-.58.27-.2.08-.4.15-.59.2v-1c.22-.06.45-.14.69-.24.25-.1.49-.22.72-.34.24-.13.46-.26.67-.4.21-.14.39-.28.54-.41h.38v8.87Z" />
				<path d="m357.07,708.76c0,.73-.07,1.37-.2,1.93-.13.56-.32,1.03-.57,1.42-.25.38-.55.68-.91.88-.36.2-.77.3-1.23.3-.44,0-.82-.09-1.17-.28-.34-.19-.63-.47-.86-.84-.23-.37-.41-.82-.53-1.35-.12-.54-.18-1.15-.18-1.84,0-.76.06-1.43.19-2.01.13-.58.32-1.07.56-1.46.25-.4.55-.69.91-.89.37-.2.79-.3,1.26-.3,1.82,0,2.73,1.48,2.73,4.45Zm-1.02.1c0-2.47-.59-3.7-1.76-3.7-1.24,0-1.86,1.26-1.86,3.77,0,2.34.61,3.51,1.82,3.51s1.8-1.19,1.8-3.58Z" />
				<path d="m359.45,704.46v2.7h-.88v-2.7h.88Zm2.01,0v2.7h-.88v-2.7h.88Z" />
				<path d="m672.7,288.95v-11.92h3.39c1.03,0,1.85.25,2.45.76s.91,1.16.91,1.97c0,.68-.18,1.26-.55,1.76-.37.5-.87.85-1.51,1.06v.03c.8.09,1.45.4,1.93.91.48.51.72,1.17.72,1.99,0,1.02-.37,1.84-1.1,2.48-.73.63-1.65.95-2.77.95h-3.47Zm1.4-10.65v3.85h1.43c.76,0,1.37-.18,1.8-.55.44-.37.66-.89.66-1.56,0-1.16-.76-1.74-2.28-1.74h-1.6Zm0,5.1v4.29h1.89c.82,0,1.45-.19,1.9-.58.45-.39.68-.92.68-1.6,0-1.41-.96-2.11-2.87-2.11h-1.6Zm15,1.64h-6.01c.02.95.28,1.68.76,2.19.49.52,1.16.77,2.01.77.96,0,1.84-.32,2.64-.95v1.28c-.75.54-1.74.81-2.97.81s-2.15-.38-2.83-1.16c-.69-.78-1.03-1.86-1.03-3.27,0-1.32.37-2.4,1.12-3.23.75-.84,1.69-1.25,2.8-1.25s1.97.36,2.58,1.08.91,1.72.91,3v.71Zm-1.4-1.16c0-.79-.2-1.4-.57-1.84-.37-.44-.89-.66-1.55-.66s-1.19.23-1.64.69-.73,1.06-.83,1.8h4.59Zm10.71,5.07h-1.36v-1.45h-.03c-.63,1.1-1.61,1.65-2.92,1.65-1.07,0-1.92-.38-2.57-1.14-.64-.76-.96-1.8-.96-3.12,0-1.41.35-2.53,1.06-3.38.71-.85,1.65-1.27,2.83-1.27s2.02.46,2.55,1.38h.03v-5.27h1.36v12.6Zm-1.36-3.85v-1.25c0-.69-.23-1.27-.68-1.74-.45-.48-1.03-.71-1.73-.71-.83,0-1.48.3-1.96.91-.48.61-.71,1.45-.71,2.53,0,.98.23,1.76.68,2.33.46.57,1.07.85,1.84.85s1.37-.27,1.84-.82c.48-.55.71-1.24.71-2.08Zm8.55-3.28c-.24-.18-.58-.27-1.03-.27-.58,0-1.07.27-1.46.82-.39.55-.58,1.3-.58,2.24v4.34h-1.36v-8.51h1.36v1.75h.03c.19-.6.49-1.06.89-1.4.4-.34.84-.51,1.34-.51.35,0,.63.04.81.12v1.41Zm5.03,7.33c-1.26,0-2.26-.4-3.02-1.19-.75-.8-1.12-1.85-1.12-3.17,0-1.43.39-2.55,1.17-3.35.78-.8,1.84-1.2,3.17-1.2s2.26.39,2.97,1.17c.71.78,1.07,1.86,1.07,3.25s-.38,2.45-1.15,3.27c-.76.81-1.79,1.22-3.08,1.22h0Zm.1-7.76c-.88,0-1.57.3-2.08.9-.51.59-.76,1.41-.76,2.46s.26,1.8.77,2.38c.52.58,1.2.87,2.07.87s1.56-.29,2.03-.86c.48-.57.71-1.38.71-2.43s-.24-1.88-.71-2.46c-.47-.58-1.15-.86-2.03-.86Zm9.86,7.76c-1.26,0-2.26-.4-3.02-1.19-.75-.8-1.12-1.85-1.12-3.17,0-1.43.39-2.55,1.17-3.35.78-.8,1.84-1.2,3.17-1.2s2.26.39,2.97,1.17c.71.78,1.07,1.86,1.07,3.25s-.38,2.45-1.15,3.27c-.76.81-1.79,1.22-3.08,1.22Zm.1-7.76c-.88,0-1.57.3-2.08.9-.51.59-.76,1.41-.76,2.46s.26,1.8.77,2.38c.52.58,1.2.87,2.07.87s1.56-.29,2.03-.86c.48-.57.71-1.38.71-2.43s-.24-1.88-.71-2.46c-.47-.58-1.15-.86-2.03-.86Zm18.39,7.56h-1.36v-4.89c0-.94-.15-1.62-.44-2.04-.29-.42-.78-.63-1.46-.63-.58,0-1.08.27-1.49.8-.4.53-.61,1.17-.61,1.91v4.85h-1.36v-5.05c0-1.67-.65-2.51-1.94-2.51-.6,0-1.09.25-1.48.76-.39.5-.58,1.15-.58,1.95v4.85h-1.36v-8.51h1.36v1.35h.03c.6-1.03,1.48-1.55,2.64-1.55.58,0,1.09.16,1.52.49.43.32.73.75.89,1.27.63-1.17,1.57-1.76,2.83-1.76,1.87,0,2.81,1.15,2.81,3.46v5.24Z" />
				<path d="m751.32,280.16c0-.37-.06-.68-.17-.96-.11-.27-.27-.5-.47-.67-.19-.18-.42-.32-.69-.41-.27-.09-.55-.13-.86-.13-.27,0-.53.04-.78.11-.25.07-.5.17-.75.3-.24.13-.47.28-.7.46-.22.18-.43.37-.62.59v-1.46c.38-.37.81-.65,1.28-.85.48-.2,1.06-.3,1.74-.3.49,0,.94.07,1.35.22.42.14.78.34,1.08.61s.54.61.71,1.01c.18.4.27.86.27,1.37,0,.47-.06.9-.17,1.28-.11.38-.27.74-.49,1.08-.22.34-.49.66-.82.97-.33.31-.72.63-1.17.95-.56.4-1.02.74-1.39,1.02-.36.28-.65.55-.86.8-.21.24-.36.49-.45.74-.08.24-.12.53-.12.85h5.93v1.22h-7.35v-.59c0-.51.06-.96.17-1.35.11-.39.29-.76.55-1.11.25-.35.59-.7,1-1.05.42-.35.92-.74,1.52-1.18.43-.31.79-.61,1.08-.89.29-.28.53-.57.71-.85.18-.28.3-.57.37-.86.08-.29.12-.6.12-.93Z" />
				<path d="m683.03,306.61h-.99v-7.49c-.08.08-.19.17-.34.27-.15.1-.31.19-.5.29-.18.1-.38.19-.58.27-.2.08-.4.15-.59.2v-1c.22-.06.45-.14.69-.24.25-.1.49-.22.72-.34.24-.13.46-.26.67-.4.21-.14.39-.28.54-.41h.38v8.87Zm6.69,0h-.99v-7.49c-.08.08-.19.17-.34.27-.15.1-.31.19-.5.29-.18.1-.38.19-.58.27-.2.08-.4.15-.59.2v-1c.22-.06.45-.14.69-.24.25-.1.49-.22.72-.34.24-.13.46-.26.67-.4.21-.14.39-.28.54-.41h.38v8.87Z" />
				<rect x="693.01" y="297.94" width=".88" height="2.7" />
				<path d="m700.91,301.76c0,.79-.08,1.5-.24,2.12-.16.62-.39,1.14-.69,1.57-.3.43-.67.75-1.11.98-.44.22-.93.33-1.49.33s-1.08-.1-1.51-.3v-.95c.48.27.99.41,1.54.41.39,0,.74-.08,1.05-.24.31-.16.57-.4.79-.7.21-.31.38-.69.49-1.14.11-.45.17-.97.17-1.55h-.02c-.37.75-1.02,1.12-1.94,1.12-.37,0-.71-.06-1.02-.19-.31-.13-.58-.32-.8-.56-.23-.24-.4-.53-.53-.86-.12-.33-.19-.7-.19-1.09,0-.43.07-.82.21-1.17.14-.35.33-.66.58-.91.25-.26.54-.46.88-.6.34-.14.72-.21,1.12-.21.44,0,.82.09,1.16.27.34.17.62.43.85.77.23.33.41.75.53,1.24.12.49.18,1.05.18,1.69Zm-1.07-.89c0-.33-.04-.64-.13-.91-.08-.27-.2-.51-.36-.7-.15-.2-.34-.35-.55-.45-.21-.11-.44-.16-.69-.16s-.46.05-.67.15c-.21.09-.39.23-.54.4-.15.17-.27.37-.36.61-.08.23-.13.49-.13.77,0,.31.04.58.12.82.08.24.2.45.36.62.15.17.34.29.55.38.22.09.46.13.72.13.23,0,.45-.04.65-.13.21-.09.38-.21.53-.35.15-.15.27-.32.36-.52.09-.2.13-.42.13-.65Z" />
				<path d="m703.38,297.94v2.7h-.88v-2.7h.88Zm2.01,0v2.7h-.88v-2.7h.88Z" />
				<path d="m715.3,300.42l-2.08,3.13,2.04,3.06h-1.16l-1.22-2.01c-.08-.13-.17-.28-.27-.47h-.02s-.11.19-.28.47l-1.24,2.01h-1.14l2.11-3.04-2.02-3.16h1.16l1.2,2.12c.09.16.18.32.26.48h.02l1.55-2.6h1.09Z" />
				<path d="m723.23,306.61h-.99v-7.49c-.08.08-.19.17-.34.27-.15.1-.31.19-.5.29-.18.1-.38.19-.58.27-.2.08-.4.15-.59.2v-1c.22-.06.45-.14.69-.24.25-.1.49-.22.72-.34.24-.13.46-.26.67-.4.21-.14.39-.28.54-.41h.38v8.87Zm6.69,0h-.99v-7.49c-.08.08-.19.17-.34.27-.15.1-.31.19-.5.29-.18.1-.38.19-.58.27-.2.08-.4.15-.59.2v-1c.22-.06.45-.14.69-.24.25-.1.49-.22.72-.34.24-.13.46-.26.67-.4.21-.14.39-.28.54-.41h.38v8.87Z" />
				<rect x="733.21" y="297.94" width=".88" height="2.7" />
				<path d="m741.21,303.86c0,.42-.07.81-.21,1.17-.14.35-.33.66-.57.92-.24.26-.53.46-.86.6-.33.14-.7.21-1.09.21-.44,0-.83-.09-1.17-.27-.34-.18-.64-.44-.88-.78-.24-.34-.42-.76-.54-1.25-.13-.49-.19-1.05-.19-1.66,0-.75.08-1.44.25-2.05.17-.62.41-1.14.71-1.58.31-.44.68-.78,1.12-1.02.44-.24.92-.36,1.46-.36.6,0,1.08.08,1.44.25v.94c-.45-.23-.92-.34-1.42-.34-.39,0-.74.09-1.05.26-.31.17-.58.42-.8.74-.22.31-.39.7-.51,1.14-.12.45-.18.95-.18,1.49h.02c.4-.72,1.06-1.08,1.98-1.08.38,0,.72.06,1.02.19.31.13.57.31.78.55.22.23.39.51.5.84.12.33.18.69.18,1.09Zm-1.02.13c0-.3-.04-.57-.11-.82-.08-.24-.19-.45-.33-.62-.14-.17-.32-.3-.53-.39-.21-.09-.45-.14-.71-.14-.25,0-.47.05-.68.14-.21.09-.39.22-.54.38-.15.16-.27.34-.36.56-.08.21-.13.43-.13.67,0,.3.04.58.13.84.08.26.2.48.36.68.15.19.33.35.54.46.21.11.45.16.71.16s.48-.05.68-.14c.21-.1.38-.23.53-.4.15-.17.26-.37.34-.6.08-.24.12-.5.12-.79Z" />
				<path d="m743.58,297.94v2.7h-.88v-2.7h.88Zm2.01,0v2.7h-.88v-2.7h.88Z" />
				<path d="m544.67,499.9h-1.94l-4.6-5.45c-.17-.2-.28-.34-.32-.42h-.03v5.87h-1.4v-11.92h1.4v5.6h.03c.08-.12.18-.26.32-.41l4.45-5.19h1.74l-5.11,5.72,5.47,6.2Zm2.08-10.67c-.24,0-.45-.08-.62-.25-.17-.17-.26-.38-.26-.63s.09-.47.26-.63c.17-.17.38-.26.62-.26s.46.09.63.26c.18.17.27.38.27.63s-.09.45-.27.62c-.17.17-.38.26-.63.26Zm.66,10.67h-1.36v-8.51h1.36v8.51Zm6.69-.08c-.32.18-.75.27-1.27.27-1.49,0-2.24-.83-2.24-2.49v-5.04h-1.46v-1.16h1.46v-2.08l1.36-.44v2.52h2.14v1.16h-2.14v4.79c0,.57.1.98.29,1.22.19.24.52.37.96.37.34,0,.64-.09.89-.28v1.16Zm7.61-.31c-.65.39-1.43.59-2.33.59-1.21,0-2.19-.39-2.94-1.18-.74-.79-1.11-1.82-1.11-3.07,0-1.4.4-2.53,1.2-3.37.8-.85,1.88-1.28,3.22-1.28.75,0,1.41.14,1.98.42v1.4c-.63-.44-1.31-.66-2.03-.66-.87,0-1.58.31-2.14.94-.55.62-.83,1.44-.83,2.45s.26,1.78.78,2.36c.53.58,1.23.86,2.11.86.74,0,1.44-.25,2.09-.74v1.3Zm9.12.39h-1.36v-4.9c0-1.77-.66-2.66-1.98-2.66-.66,0-1.22.26-1.68.77-.45.51-.68,1.17-.68,1.97v4.82h-1.36v-12.6h1.36v5.5h.03c.65-1.07,1.58-1.61,2.79-1.61,1.92,0,2.87,1.15,2.87,3.46v5.24Zm9.4-3.91h-6.01c.02.95.28,1.68.76,2.19.49.52,1.16.77,2.01.77.96,0,1.84-.32,2.64-.95v1.28c-.75.54-1.74.81-2.97.81s-2.15-.38-2.83-1.15c-.69-.78-1.03-1.86-1.03-3.27,0-1.32.37-2.4,1.12-3.23.75-.84,1.69-1.25,2.8-1.25s1.97.36,2.58,1.08c.61.72.91,1.72.91,3v.71Zm-1.4-1.15c0-.79-.2-1.4-.57-1.84-.37-.44-.89-.66-1.55-.66s-1.19.23-1.64.69c-.45.46-.73,1.06-.83,1.8h4.59Zm10.51,5.07h-1.36v-4.85c0-1.81-.66-2.71-1.98-2.71-.68,0-1.25.26-1.7.77-.44.51-.66,1.15-.66,1.94v4.85h-1.36v-8.51h1.36v1.41h.03c.64-1.07,1.57-1.61,2.79-1.61.93,0,1.64.3,2.14.91.49.6.74,1.47.74,2.6v5.2Z" />
				<path d="m730.11,738.18h-6.31v-11.92h6.05v1.26h-4.65v3.96h4.3v1.25h-4.3v4.17h4.92v1.26Zm9.19,0h-1.36v-4.85c0-1.81-.66-2.71-1.98-2.71-.68,0-1.25.26-1.7.77-.44.51-.66,1.15-.66,1.94v4.85h-1.36v-8.51h1.36v1.41h.03c.64-1.07,1.57-1.61,2.79-1.61.93,0,1.64.3,2.14.91.49.6.74,1.47.74,2.6v5.2Zm6.53-.08c-.32.18-.75.27-1.27.27-1.49,0-2.24-.83-2.24-2.49v-5.04h-1.46v-1.16h1.46v-2.08l1.36-.44v2.52h2.14v1.16h-2.14v4.79c0,.57.1.98.29,1.22.19.24.52.37.96.37.34,0,.64-.09.89-.28v1.16Zm6.27-7.05c-.24-.18-.58-.27-1.03-.27-.58,0-1.07.27-1.46.82-.39.55-.58,1.3-.58,2.24v4.34h-1.36v-8.51h1.36v1.75h.03c.19-.6.49-1.06.89-1.4.4-.34.84-.51,1.34-.51.35,0,.63.04.81.12v1.41Zm8.27-1.38l-3.91,9.87c-.7,1.76-1.68,2.64-2.94,2.64-.35,0-.65-.04-.89-.11v-1.22c.29.1.56.15.81.15.69,0,1.2-.41,1.55-1.23l.68-1.61-3.32-8.49h1.51l2.3,6.55c.03.08.09.3.17.65h.05c.03-.13.08-.34.17-.63l2.42-6.56h1.41Z" />
				<path d="m849.4,528.21v-11.92h3.39c1.03,0,1.85.25,2.45.76.6.5.91,1.16.91,1.97,0,.68-.18,1.26-.55,1.76-.37.5-.87.85-1.51,1.06v.03c.8.09,1.45.4,1.93.91.48.51.72,1.17.72,1.99,0,1.02-.37,1.84-1.1,2.48-.73.63-1.65.95-2.77.95h-3.47Zm1.4-10.65v3.85h1.43c.76,0,1.37-.18,1.8-.55.44-.37.66-.89.66-1.56,0-1.16-.76-1.74-2.28-1.74h-1.6Zm0,5.1v4.29h1.89c.82,0,1.45-.19,1.9-.58.45-.39.68-.92.68-1.6,0-1.41-.96-2.11-2.87-2.11h-1.6Zm14.26,5.55h-1.36v-1.33h-.03c-.59,1.02-1.47,1.53-2.62,1.53-.85,0-1.51-.22-1.99-.67-.48-.45-.71-1.04-.71-1.79,0-1.59.94-2.51,2.81-2.78l2.55-.36c0-1.45-.58-2.17-1.75-2.17-1.02,0-1.95.35-2.78,1.05v-1.4c.84-.53,1.8-.8,2.89-.8,2,0,3,1.06,3,3.17v5.53Zm-1.36-4.3l-2.05.28c-.63.09-1.11.25-1.43.47-.32.22-.48.62-.48,1.19,0,.42.15.76.44,1.02.3.26.7.39,1.19.39.68,0,1.23-.24,1.67-.71.44-.48.66-1.08.66-1.8v-.85Zm7.88,4.22c-.32.18-.75.27-1.27.27-1.49,0-2.24-.83-2.24-2.49v-5.04h-1.46v-1.16h1.46v-2.08l1.36-.44v2.52h2.14v1.16h-2.14v4.79c0,.57.1.98.29,1.22.19.24.52.37.96.37.34,0,.64-.09.89-.28v1.16Zm8.89.08h-1.36v-4.9c0-1.77-.66-2.66-1.98-2.66-.66,0-1.22.26-1.68.77-.45.51-.68,1.17-.68,1.97v4.82h-1.36v-12.6h1.36v5.5h.03c.65-1.07,1.58-1.61,2.79-1.61,1.92,0,2.87,1.16,2.87,3.46v5.24Z" />
				<path d="m529.04,635.75v-11.92h3.39c1.03,0,1.85.25,2.45.76.6.5.91,1.16.91,1.97,0,.68-.18,1.26-.55,1.76-.37.5-.87.85-1.51,1.06v.03c.8.09,1.45.4,1.93.91.48.51.72,1.17.72,1.99,0,1.02-.37,1.84-1.1,2.48-.73.63-1.65.95-2.77.95h-3.47Zm1.4-10.65v3.85h1.43c.76,0,1.37-.18,1.8-.55.44-.37.66-.89.66-1.56,0-1.16-.76-1.74-2.28-1.74h-1.6Zm0,5.1v4.29h1.89c.82,0,1.45-.19,1.9-.58.45-.39.68-.92.68-1.6,0-1.41-.96-2.11-2.87-2.11h-1.6Zm14.26,5.55h-1.36v-1.33h-.03c-.59,1.02-1.47,1.53-2.62,1.53-.85,0-1.51-.22-1.99-.67-.48-.45-.71-1.04-.71-1.79,0-1.59.94-2.51,2.81-2.78l2.55-.36c0-1.45-.58-2.17-1.75-2.17-1.02,0-1.95.35-2.78,1.05v-1.4c.84-.53,1.8-.8,2.89-.8,2,0,3,1.06,3,3.17v5.53Zm-1.36-4.3l-2.05.28c-.63.09-1.11.25-1.43.47-.32.22-.48.62-.48,1.19,0,.42.15.76.44,1.02.3.26.7.39,1.19.39.68,0,1.23-.24,1.67-.71.44-.48.66-1.08.66-1.8v-.85Zm7.88,4.22c-.32.18-.75.27-1.27.27-1.49,0-2.24-.83-2.24-2.49v-5.04h-1.46v-1.16h1.46v-2.08l1.36-.44v2.52h2.14v1.16h-2.14v4.79c0,.57.1.98.29,1.22.19.24.52.37.96.37.34,0,.64-.09.89-.28v1.16Zm8.89.08h-1.36v-4.9c0-1.77-.66-2.66-1.98-2.66-.66,0-1.22.26-1.68.77-.45.51-.68,1.17-.68,1.97v4.82h-1.36v-12.6h1.36v5.5h.03c.65-1.07,1.58-1.61,2.79-1.61,1.92,0,2.87,1.15,2.87,3.46v5.24Z" />
				<path d="m148.8,357.11v4.5h-1.4v-11.92h3.27c1.27,0,2.26.31,2.96.93.7.62,1.06,1.5,1.06,2.63s-.39,2.06-1.17,2.78c-.78.72-1.83,1.08-3.15,1.08h-1.57Zm0-6.15v4.89h1.46c.96,0,1.7-.22,2.2-.66.51-.44.76-1.07.76-1.87,0-1.57-.93-2.36-2.79-2.36h-1.64Zm13.92,10.65h-1.36v-1.33h-.03c-.59,1.02-1.47,1.53-2.62,1.53-.85,0-1.51-.22-1.99-.67-.48-.45-.71-1.04-.71-1.79,0-1.59.94-2.51,2.81-2.78l2.55-.36c0-1.45-.58-2.17-1.75-2.17-1.02,0-1.95.35-2.78,1.05v-1.4c.84-.53,1.8-.8,2.89-.8,2,0,3,1.06,3,3.17v5.53Zm-1.36-4.3l-2.05.28c-.63.09-1.11.25-1.43.47-.32.22-.48.62-.48,1.19,0,.42.15.76.44,1.02.3.26.7.39,1.19.39.68,0,1.23-.24,1.67-.71.44-.48.66-1.08.66-1.8v-.85Zm7.76,4.22c-.32.18-.75.27-1.27.27-1.49,0-2.24-.83-2.24-2.49v-5.04h-1.46v-1.16h1.46v-2.08l1.36-.44v2.52h2.14v1.16h-2.14v4.79c0,.57.1.98.29,1.22s.52.37.96.37c.34,0,.64-.09.89-.28v1.16Zm2.4-10.59c-.24,0-.45-.08-.62-.25-.17-.17-.26-.38-.26-.63s.09-.47.26-.63c.17-.17.38-.26.62-.26s.46.09.63.26c.18.17.27.38.27.63s-.09.45-.27.62c-.17.17-.38.26-.63.26Zm.66,10.67h-1.36v-8.51h1.36v8.51Zm6.19.2c-1.26,0-2.26-.4-3.02-1.19-.75-.8-1.12-1.85-1.12-3.17,0-1.43.39-2.55,1.17-3.35.78-.8,1.84-1.2,3.17-1.2s2.26.39,2.97,1.17c.71.78,1.07,1.86,1.07,3.25s-.38,2.45-1.15,3.27c-.76.81-1.79,1.22-3.08,1.22Zm.1-7.76c-.88,0-1.57.3-2.08.9-.51.59-.76,1.41-.76,2.46s.26,1.8.77,2.38c.52.58,1.2.87,2.07.87s1.56-.29,2.03-.86c.48-.57.71-1.38.71-2.43s-.24-1.88-.71-2.46c-.47-.58-1.15-.86-2.03-.86Z" />
				<polygon points="190.04 349.69 184.33 363.59 183.06 363.59 188.76 349.69 190.04 349.69" />
				<path d="m191.43,361.61v-11.92h3.39c1.03,0,1.85.25,2.45.76.6.5.91,1.16.91,1.97,0,.68-.18,1.26-.55,1.76-.37.5-.87.85-1.51,1.06v.03c.8.09,1.45.4,1.93.91.48.51.72,1.17.72,1.99,0,1.02-.37,1.84-1.1,2.48-.73.63-1.65.95-2.77.95h-3.47Zm1.4-10.65v3.85h1.43c.76,0,1.37-.18,1.8-.55.44-.37.66-.89.66-1.56,0-1.16-.76-1.74-2.29-1.74h-1.6Zm0,5.1v4.29h1.89c.82,0,1.45-.19,1.9-.58.45-.39.68-.92.68-1.6,0-1.41-.96-2.11-2.87-2.11h-1.6Zm14.26,5.55h-1.36v-1.33h-.03c-.59,1.02-1.47,1.53-2.62,1.53-.85,0-1.51-.22-1.99-.67-.48-.45-.71-1.04-.71-1.79,0-1.59.94-2.51,2.81-2.78l2.55-.36c0-1.45-.58-2.17-1.75-2.17-1.02,0-1.95.35-2.78,1.05v-1.4c.84-.53,1.8-.8,2.89-.8,2,0,3,1.06,3,3.17v5.53Zm-1.36-4.3l-2.05.28c-.63.09-1.11.25-1.43.47-.32.22-.48.62-.48,1.19,0,.42.15.76.44,1.02.3.26.7.39,1.19.39.68,0,1.23-.24,1.67-.71.44-.48.66-1.08.66-1.8v-.85Zm5.29,4.3h-1.36v-12.6h1.36v12.6Zm8.55-.39c-.65.39-1.43.59-2.33.59-1.21,0-2.19-.39-2.94-1.18-.74-.79-1.11-1.82-1.11-3.07,0-1.4.4-2.53,1.2-3.37.8-.85,1.88-1.28,3.22-1.28.75,0,1.41.14,1.98.42v1.4c-.63-.44-1.31-.66-2.03-.66-.87,0-1.58.31-2.14.94-.55.62-.83,1.44-.83,2.45s.26,1.78.78,2.36c.53.58,1.23.86,2.11.86.74,0,1.44-.25,2.09-.74v1.3Zm5.62.59c-1.26,0-2.26-.4-3.02-1.19-.75-.8-1.12-1.85-1.12-3.17,0-1.43.39-2.55,1.17-3.35s1.84-1.2,3.17-1.2,2.26.39,2.97,1.17c.71.78,1.07,1.86,1.07,3.25s-.38,2.45-1.15,3.27c-.76.81-1.79,1.22-3.08,1.22Zm.1-7.76c-.88,0-1.57.3-2.08.9-.51.59-.76,1.41-.76,2.46s.26,1.8.77,2.38c.52.58,1.2.87,2.07.87s1.56-.29,2.03-.86c.48-.57.71-1.38.71-2.43s-.24-1.88-.71-2.46c-.47-.58-1.15-.86-2.03-.86Zm13.38,7.56h-1.36v-4.85c0-1.81-.66-2.71-1.98-2.71-.68,0-1.25.26-1.7.77-.44.51-.66,1.15-.66,1.94v4.85h-1.36v-8.51h1.36v1.41h.03c.64-1.07,1.57-1.61,2.79-1.61.93,0,1.64.3,2.14.91.49.6.74,1.47.74,2.6v5.2Zm9.34-8.51l-3.91,9.87c-.7,1.76-1.68,2.64-2.94,2.64-.35,0-.65-.04-.89-.11v-1.22c.29.1.56.15.81.15.69,0,1.2-.41,1.55-1.23l.68-1.61-3.32-8.49h1.51l2.3,6.55c.03.08.09.3.17.65h.05c.03-.13.08-.34.17-.63l2.42-6.56h1.41Z" />
				<path d="m661.77,629.36l-2.14,7.59h-1.04l-1.56-5.55c-.07-.24-.11-.49-.12-.77h-.02c-.02.26-.07.52-.14.76l-1.57,5.56h-1.03l-2.22-7.59h.98l1.61,5.82c.07.24.11.5.13.76h.03c.02-.19.07-.44.16-.76l1.68-5.82h.85l1.61,5.86c.06.2.1.44.13.71h.02c.01-.18.06-.43.14-.73l1.55-5.84h.96Z" />
				<polygon points="666.19 629.36 662.55 638.21 661.74 638.21 665.37 629.36 666.19 629.36" />
				<path d="m667.07,636.95v-7.59h2.1c2.67,0,4.01,1.23,4.01,3.7,0,1.17-.37,2.11-1.12,2.83-.74.71-1.73,1.06-2.98,1.06h-2.01Zm.89-6.79v5.98h1.13c1,0,1.77-.27,2.32-.8.55-.53.83-1.29.83-2.27,0-1.94-1.03-2.92-3.1-2.92h-1.19Z" />
			</g>
		</g>
	)
}

export default PlanKK
